
$(document).ready(function () {
    const scrollTarget = "#app_customer-reivews";
    const productPagePath = "/products/focus-fuel"; // <-- UPDATE this to your actual product URL path

    // When link is clicked
    $('a[href="' + scrollTarget + '"]').on("click", function (event) {
        event.preventDefault();

        if (window.location.pathname !== productPagePath) {
            // Save the target section in localStorage
            localStorage.setItem("scrollToSection", scrollTarget);
            window.location.href = productPagePath;
        } else {
            // Already on the product page
            smoothScroll(scrollTarget);
        }
    });

    // Smooth scroll function
    function smoothScroll(selector) {
        if ($(selector).length) {
            $("html, body").animate(
                {
                    scrollTop: $(selector).offset().top
                },
                800,
                "swing"
            );
        }
    }

    // If redirected, scroll to the section
    if (localStorage.getItem("scrollToSection")) {
        const section = localStorage.getItem("scrollToSection");
        localStorage.removeItem("scrollToSection");

        // Delay to ensure section exists
        setTimeout(function () {
            smoothScroll(section);
        }, 500);
    }
});







// $("[href^='#']").click(function() {
//     id=$(this).attr("href")
//     $('html, body').animate({
//         scrollTop: $(id).offset().top
//     }, 1000);
//   });











$(".tab_controllers .tab_btn").click(function () {
  $(".tab_btn.active").removeClass("active");
  let target = $(this).addClass("active").data("target");
  $(".tab.active").removeClass("active");
  $(`.tab[data-tab='${target}']`).addClass("active");
});


$(document).ready(function () {
  $(".instant-video__button").on("click", function () {
      var $wrapper = $(this).closest(".instant-video__wrapper");
      var videoSrc = $wrapper.data("src"); // Get YouTube embed URL

      // Ensure autoplay is properly included in the URL
      if (videoSrc.includes("?")) {
          videoSrc += "&autoplay=1";
      } else {
          videoSrc += "?autoplay=1";
      }

      // Create the iframe for the video
      var iframe = `<iframe width="100%" height="100%" src="${videoSrc}" frameborder="0" allow="autoplay" allowfullscreen></iframe>`;

      // Hide play button
      $(this).hide();

      // Append iframe inside the wrapper
      $wrapper.html(iframe);
  });
});

$("#hamburger").on("click",function(){
  $(".mob_menu").addClass("open");
  $(".mob_menu span").text("Close");
  $(".m_menu_holder").addClass("open");

})
$("#mobile-close").on("click",function(){

  $(".mob_menu").removeClass("open");
  $(".mob_menu span").text("Menu");
  $(".m_menu_holder").removeClass("open");

})




var tab_product_two = new Swiper('.tab-product__inner .desktop .tab[data-tab="tab-2"] .swiper', {
  slidesPerView: 2,
  spaceBetween: 12,
  breakpoints: { 450: { slidesPerView: 3, spaceBetween: 12 }, 768: { slidesPerView: 4, spaceBetween: 13 } },
  navigation: { nextEl: '.tab-product__inner .tab[data-tab="tab-2"] .swiper-button.button-next', prevEl: '.tab-product__inner .tab[data-tab="tab-2"] .swiper-button.button-prev' },
});


// const processChange = debounce((event) => perform_search($("#-template--17722348994743__hp_one_daily_serving_LQkwzy .search_input input").val()));


var tab_product_one = new Swiper('.tab-product__inner .desktop .tab[data-tab="tab-1"] .swiper', {
  slidesPerView: 2,
  spaceBetween: 12,
  breakpoints: { 450: { slidesPerView: 3, spaceBetween: 12 }, 768: { slidesPerView: 4, spaceBetween: 13 } },
  navigation: { nextEl: '.tab-product__inner .tab[data-tab="tab-1"] .swiper-button.button-next', prevEl: '.tab-product__inner .tab[data-tab="tab-1"] .swiper-button.button-prev' },
});

var tab_product_three = new Swiper('.tab-product__inner .desktop .tab[data-tab="tab-3"] .swiper', {
  slidesPerView: 2,
  spaceBetween: 12,
  breakpoints: { 450: { slidesPerView: 3, spaceBetween: 12 }, 768: { slidesPerView: 4, spaceBetween: 13 } },
  navigation: { nextEl: '.tab-product__inner .tab[data-tab="tab-3"] .swiper-button.button-next', prevEl: '.tab-product__inner .tab[data-tab="tab-3"] .swiper-button.button-prev' },
});



// custom revivew js start here 

const bigScreenSlides = 5;
const bigScreenGap = 24;

const lpReviewsSwiper = new Swiper('.lp-reviews__swiper', {
  loop: true,
  autoplay: {
    delay: 8000,
  },
  navigation: {
    nextEl: '.lp-reviews__pagination-buttons .swiper-button-next',
    prevEl: '.lp-reviews__pagination-buttons .swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    320: {
      centeredSlides: true,
      slidesPerView: 1,
      spaceBetween: 14,
    },
    480: {
      slidesPerView: 1,
      spaceBetween: 14,
    },
    992: {
      centeredSlides: true,
      slidesPerView: 2,
      spaceBetween: bigScreenGap,
    },
    1200: {
      slidesPerView: bigScreenSlides,
      spaceBetween: bigScreenGap,
    },
    1500: {
      slidesPerView: bigScreenSlides,
      spaceBetween: bigScreenGap,
    },
    1920: {
      slidesPerView: bigScreenSlides,
      spaceBetween: bigScreenGap,
    }
  }
});


// custom revivew js end here 


// ingredients js start here 

$(".ingredients__inner .nutration").click(function () {
  var imge= $(this).find(".nu_icon").attr("src");
  $(".ingredient_modal img").attr("src",imge);
  show_ingre_popup();
});

$(".ingredients__inner .ingrediants").click(function () {
  var imge= $(this).find(".nu_icon").attr("src");
  console.log(imge)
  $(".ingredient_modal img").attr("src",imge);
  show_ingre_popup();
});

$(".ingredients__inner .ingre_table_overlay").click(function () {
  hide_ingre_popup();
});
function show_ingre_popup() {
  $(".ingredients__inner .ingre_table_overlay").fadeIn(400);
  $(".ingredients__inner .ingredient_modal").fadeIn(300);
}
function hide_ingre_popup() {
  $(".ingredients__inner .ingre_table_overlay").fadeOut(400);
  $(".ingredients__inner .ingredient_modal").fadeOut(300);
}


// ingredients js end here 

// sample section js start here 


var sample_2 = new Swiper('.smaple__inner .desktop .tab[data-tab="tab-1"] .swiper', {
  slidesPerView: 2,
  spaceBetween: 12,
  breakpoints: { 450: { slidesPerView: 3, spaceBetween: 12 }, 768: { slidesPerView: 4, spaceBetween: 13 } },
  navigation: { nextEl: '.smaple__inner .tab[data-tab="tab-1"] .swiper-button.button-next', prevEl: '.smaple__inner .tab[data-tab="tab-1"] .swiper-button.button-prev' },
});
var sample_2 = new Swiper('.smaple__inner .desktop .tab[data-tab="tab-2"] .swiper', {
  slidesPerView: 2,
  spaceBetween: 12,
  breakpoints: { 450: { slidesPerView: 3, spaceBetween: 12 }, 768: { slidesPerView: 4, spaceBetween: 13 } },
  navigation: { nextEl: '.smaple__inner .tab[data-tab="tab-2"] .swiper-button.button-next', prevEl: '.smaple__inner .tab[data-tab="tab-2"] .swiper-button.button-prev' },
});

$(".tab_controllers .tab_btn").click(function () {
  $(".tab_btn.active").removeClass("active");
  let target = $(this).addClass("active").data("target");
  $(".tab.active").removeClass("active");
  $(`.tab[data-tab='${target}']`).addClass("active");
});

// sample section js end here 


// faq section css start here 
$(".faq__inner .q").click(function () {
  $(this).toggleClass("slided");
  $(".faq__inner .q").not(this).removeClass("slided");
  $(this).next().slideToggle();
  $(".faq__inner .q").not(this).next().slideUp();
});


// faq section css end here 


// currency js start here 

class CurrencySelector extends HTMLElement {
  constructor() {
      super();
      this.form = this.querySelector("form");
      this.button = this.querySelector(".currency__toggle");
      this.curList = this.querySelectorAll(".currency-list__item");
      this.input = this.querySelector('input[name="currency_code"]');
      this.addAction();
  }
  addAction() {
      this.button.addEventListener("click", this.open.bind(this));
      this.curList.forEach((currency) => currency.addEventListener("click", this.onSubCurrency.bind(this)));
  }
  open() {
      this.classList.toggle("open");
  }
  onSubCurrency(ev) {
      console.log(ev);
      let currency = ev.target.dataset["value"];
      this.input.value = currency;
      console.log(this.input.value);
      let t = setTimeout(() => {
          clearTimeout(t);
          this.form.submit();
      }, 300);
  }
}
// customElements.define("currency-selector", CurrencySelector);

// currency js end here 

// announcement cuntdown start here 

$(document).ready(function() {
  function updateCountdown() {
      const now = new Date();
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
      const diff = midnight - now;

      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      $(".an_h").text(String(hours).padStart(2, '0'));
      $(".an_min").text(String(minutes).padStart(2, '0'));
      $(".an_s").text(String(seconds).padStart(2, '0'));
  }

  setInterval(updateCountdown, 1000);
  updateCountdown(); // Run once immediately to avoid delay
});


// announcement cuntdown end here 



// collection tab section js start here 

$(".s_col").click(function () {
  $(".s_col.selected").removeClass("selected");
  $(this).addClass("selected");
  var handle = $(this).attr("col_handle");
  $.ajax({
      method: "GET",
      url: `/collections/${handle}?section_id=collection_products_grid`,
      success: function (response) {
          $(`.col_p_grid_section`).find(".section_holder").empty().append($(response).find(".section_holder").children());
      },
  });
});


// collection tab section js end here 

// best selling js start here 

const best__selling = new Swiper(".best-selling__inner .swiper", {
  slidesPerView: 2,
  spaceBetween: 12,
  loop: true,
  breakpoints: { 450: { slidesPerView: 3, spaceBetween: 13 }, 768: { slidesPerView: 4, spaceBetween: 13 } },
  navigation: { nextEl: ".best-selling__inner .swiper-button.button-next", prevEl: ".best-selling__inner .swiper-button.button-prev" },
});
// best selling js end here 




// main product js start here 


// $('.s_sub_quan_selector.in_two_options_holder.Flavour').on("click", function () {
      //     update_saving_price_subs();
      // });
  
      function update_saving_price_subs() {
          // var flavor = $('.s_sub_quan_selector.in_two_options_holder.Flavour.selected .s_quan_txt').text();
        var flavor = $('.flavour-option').find('.option_selector.selected').attr('option-value-handle');
        console.log(`flavor 333 - ${flavor}`);
  
        
          
          $('.quantity-option .s_sub_quan_selector').each(function () {
              var quantity = $(this).attr('option-value');
  
              var saving_price = '';
              var quantity_selector = $(this);
              var currentOptionTitle = $(this).attr('option-value-handle');
              var currentBadge;
  
  
            $('.pp_variant_checker').each(function(){
              var currentId = $(this).attr('data-id');
              var currentTitle = $(this).attr('data-title');
              
  
              var checker = $(this);
              
              var fullTitle = flavor + '-' + currentOptionTitle;
  
              if (fullTitle == currentTitle){
                currentBadge = checker.attr('data-discount');
              }
  
              console.log(fullTitle, currentBadge, 'TESTING BADGE');
              
            });
  
  
            if (typeof(currentBadge) != 'undefined'){
              quantity_selector.find('.s_sub_saving_badge').html(currentBadge);
              console.log('FOUND OUT SALE BADGE', currentBadge);
           
            }
            
            
              // $('.selector_content[from="subs"] .s_sub_quan_selector').not('.in_two_options_holder').each(function () {
              //     var option_value_name = $(this).find(".s_quan_txt").text();
              //     if (option_value_name.indexOf(quantity) != -1 && option_value_name.indexOf(flavor) != -1) {
              //         // saving_price = $(this).find('.s_sub_saving_badge').html();
              //         // quantity_selector.find('.s_sub_saving_badge').html(saving_price);
  
              //       console.log('found ==== ');
              //     }
              // });
          });
      }
  
      update_saving_price_subs();
  

// $('.s_sub_quan_selector.in_two_options_holder.Flavour').on("click", function () {
      //     update_saving_price_subs();
      // });
  
      function update_saving_price_subs() {
          // var flavor = $('.s_sub_quan_selector.in_two_options_holder.Flavour.selected .s_quan_txt').text();
        var flavor = $('.flavour-option').find('.option_selector.selected').attr('option-value-handle');
        console.log(`flavor 333 - ${flavor}`);
  
        
          
          $('.quantity-option .s_sub_quan_selector').each(function () {
              var quantity = $(this).attr('option-value');
  
              var saving_price = '';
              var quantity_selector = $(this);
              var currentOptionTitle = $(this).attr('option-value-handle');
              var currentBadge;
  
  
            $('.pp_variant_checker').each(function(){
              var currentId = $(this).attr('data-id');
              var currentTitle = $(this).attr('data-title');
              
  
              var checker = $(this);
              
              var fullTitle = flavor + '-' + currentOptionTitle;
  
              if (fullTitle == currentTitle){
                currentBadge = checker.attr('data-discount');
              }
  
              console.log(fullTitle, currentBadge, 'TESTING BADGE');
              
            });
  
  
            if (typeof(currentBadge) != 'undefined'){
              quantity_selector.find('.s_sub_saving_badge').html(currentBadge);
              console.log('FOUND OUT SALE BADGE', currentBadge);
           
            }
            
            
              // $('.selector_content[from="subs"] .s_sub_quan_selector').not('.in_two_options_holder').each(function () {
              //     var option_value_name = $(this).find(".s_quan_txt").text();
              //     if (option_value_name.indexOf(quantity) != -1 && option_value_name.indexOf(flavor) != -1) {
              //         // saving_price = $(this).find('.s_sub_saving_badge').html();
              //         // quantity_selector.find('.s_sub_saving_badge').html(saving_price);
  
              //       console.log('found ==== ');
              //     }
              // });
          });
      }
  
      update_saving_price_subs();



      // const selling_plan_picker = document.querySelector('#selling_plan_picker');

      // selling_plan_picker.addEventListener('change', () => {
 
      //     let value = selling_plan_picker.value;
      //     const selectedEl = selling_plan_picker.querySelector(`[value="${value}"]`);
      //     console.log(selectedEl);
    
      //     $('.main_cta').attr('s_id', value);
      //     $('.main_cta span.total_price').html(selectedEl.dataset['price']);

      //     $('.p_price').html(selectedEl.dataset['price']);
      //     document.querySelector('.s_selector.selected').dataset['price'] = selectedEl.dataset['price'];
          
      //     console.log(selectedEl.dataset['perbag']);
      //     $(`.s_selector[for="${target_state}"] .subs_saving_price`).html(selectedEl.dataset['perbag']);
      //     $(`.s_selector[for="${target_state}"] .per-serving`).html(selectedEl.dataset['perserving']);
      //     $(`.s_selector[for="${target_state}"]`).attr('s_id', selectedEl.value);

         
      // });




      function update_pdp_slider_img(v_id) {
          var img_id = variant_image_ids[v_id];
          console.log(img_id);
  
          if (img_id != undefined) {
              var swiper_index = parseInt($('[img_id="' + img_id + '"]').parent().attr('index'));
  
              main_swiper.slideTo(0);
              $('.swip_thumb_image__js').hide();
              $('.swip_thumb_image__js[data-id="'+v_id+'"]').show();
  
  
              $('.s_sub_usp.s_sub_usp_specific_variant').hide();
              $('.s_sub_usp.s_sub_usp_specific_variant[data-id="'+v_id+'"]').show();
          }
      }
      $('.s_selector').click(function () {
          $('.s_selector').removeClass('selected');
          $(this).addClass('selected');
  
          target_state = $(this).attr('for');
  
          $('.selector_content').hide();
          $(`.selector_content[from="${target_state}"]`).show();
  
          $('.main_cta').attr('s_id', $(this).attr('s_id'));
          $('.main_cta span.total_price').html(document.querySelector('.s_selector.selected').dataset['price']);
          $('.p_price').html(document.querySelector('.s_selector.selected').dataset['price']);
  
          $('.selector_content[from="' + $(this).attr('for') + '"]').find('.selected').trigger('click');
  
        setTimeout(function(){
           $('.s_sub_quan_selector.in_two_options_holder.Coffee.option_selector').trigger('click');
         },500);
      });





      const variantInfo = [];
      let tabState = 'free';
      let selectedSubscriptionVariantId = 43654516900023;
      let selectedSellingPlanId = 1392902327;
      
      let selectedVariantOptions = [];
      
        selectedVariantOptions.push('Coffee');
      
        selectedVariantOptions.push('1x bag + free accessories with 1st order');
      
  
      let freeAccessoriesSelectedVariantOptions = selectedVariantOptions;
      
      let noAccessoriesSelectedVariantOptions = [];
      
        noAccessoriesSelectedVariantOptions.push('Coffee');
      
        noAccessoriesSelectedVariantOptions.push('1x bag | no accessories');
      
  
      let freeAccessoriesSellingPlanId = selectedSellingPlanId;
      let noAccessoriesSellingPlanId = 1393197239;
  
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1392902327,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£1.30</span>/serving)",
            subs_saving_price: "<span class=money>£39.00</span>",
            price: "<span class=money>£39.00</span>",
            
              compare_price: "<span class=money>£125.00</span>",
              saving_price: "<span class=money>£86</span>",
              saving_html: "save " + "69" + "%",
            
            shoppay_price: "<span class=money>£9.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89353377_1000x.jpg?v=1739342251"
          });
        
          
          
          
          selling_plans.push({
            id: 1392935095,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.76</span>/serving)",
            subs_saving_price: "<span class=money>£23.00</span>",
            price: "<span class=money>£69.00</span>",
            
              compare_price: "<span class=money>£223.00</span>",
              saving_price: "<span class=money>£154</span>",
              saving_html: "save " + "69" + "%",
            
            shoppay_price: "<span class=money>£17.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89353377_1000x.jpg?v=1739342251"
          });
        
          
          
          
          selling_plans.push({
            id: 1392967863,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.66</span>/serving)",
            subs_saving_price: "<span class=money>£19.83</span>",
            price: "<span class=money>£119.00</span>",
            
              compare_price: "<span class=money>£370.00</span>",
              saving_price: "<span class=money>£251</span>",
              saving_html: "save " + "68" + "%",
            
            shoppay_price: "<span class=money>£29.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89353377_1000x.jpg?v=1739342251"
          });
        
        var options = '';
        
          options += 'Coffee';
          
            options += ',';
          
        
          options += '1x bag + free accessories with 1st order';
          
        
        variantInfo.push({
          id: 43654516900023,
          options,
          title: "Coffee / 1x bag + free accessories with 1st order",
          price: "<span class=money>£39.00</span>",
          compare_price: "<span class=money>£125.00</span>",
          shoppay_price: "<span class=money>£9.75</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£86.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89353377_1000x.jpg?v=1739342251",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393000631,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.98</span>/serving)",
            subs_saving_price: "<span class=money>£29.50</span>",
            price: "<span class=money>£59.00</span>",
            
              compare_price: "<span class=money>£193.00</span>",
              saving_price: "<span class=money>£134</span>",
              saving_html: "save " + "69" + "%",
            
            shoppay_price: "<span class=money>£14.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89407618_1000x.webp?v=1739342346"
          });
        
          
          
          
          selling_plans.push({
            id: 1393033399,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.71</span>/serving)",
            subs_saving_price: "<span class=money>£21.50</span>",
            price: "<span class=money>£129.00</span>",
            
              compare_price: "<span class=money>£370.00</span>",
              saving_price: "<span class=money>£241</span>",
              saving_html: "save " + "65" + "%",
            
            shoppay_price: "<span class=money>£32.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89407618_1000x.webp?v=1739342346"
          });
        
          
          
          
          selling_plans.push({
            id: 1393066167,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.63</span>/serving)",
            subs_saving_price: "<span class=money>£19.08</span>",
            price: "<span class=money>£229.00</span>",
            
              compare_price: "<span class=money>£664.00</span>",
              saving_price: "<span class=money>£435</span>",
              saving_html: "save " + "66" + "%",
            
            shoppay_price: "<span class=money>£57.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89407618_1000x.webp?v=1739342346"
          });
        
        var options = '';
        
          options += 'Coffee';
          
            options += ',';
          
        
          options += '2x bags + free accessories with 1st order';
          
        
        variantInfo.push({
          id: 43654516998327,
          options,
          title: "Coffee / 2x bags + free accessories with 1st order",
          price: "<span class=money>£59.00</span>",
          compare_price: "<span class=money>£193.00</span>",
          shoppay_price: "<span class=money>£14.75</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£134.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89407618_1000x.webp?v=1739342346",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393098935,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.82</span>/serving)",
            subs_saving_price: "<span class=money>£24.66</span>",
            price: "<span class=money>£74.00</span>",
            
              compare_price: "<span class=money>£261.00</span>",
              saving_price: "<span class=money>£187</span>",
              saving_html: "save " + "72" + "%",
            
            shoppay_price: "<span class=money>£18.50</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354686_1000x.jpg?v=1739342371"
          });
        
          
          
          
          selling_plans.push({
            id: 1393131703,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.66</span>/serving)",
            subs_saving_price: "<span class=money>£19.88</span>",
            price: "<span class=money>£179.00</span>",
            
              compare_price: "<span class=money>£517.00</span>",
              saving_price: "<span class=money>£338</span>",
              saving_html: "save " + "65" + "%",
            
            shoppay_price: "<span class=money>£44.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354686_1000x.jpg?v=1739342371"
          });
        
          
          
          
          selling_plans.push({
            id: 1393164471,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.62</span>/serving)",
            subs_saving_price: "<span class=money>£18.83</span>",
            price: "<span class=money>£339.00</span>",
            
              compare_price: "<span class=money>£958.00</span>",
              saving_price: "<span class=money>£619</span>",
              saving_html: "save " + "65" + "%",
            
            shoppay_price: "<span class=money>£84.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354686_1000x.jpg?v=1739342371"
          });
        
        var options = '';
        
          options += 'Coffee';
          
            options += ',';
          
        
          options += '3x bags + free accessories with 1st order';
          
        
        variantInfo.push({
          id: 43654517096631,
          options,
          title: "Coffee / 3x bags + free accessories with 1st order",
          price: "<span class=money>£74.00</span>",
          compare_price: "<span class=money>£261.00</span>",
          shoppay_price: "<span class=money>£18.50</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£187.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354686_1000x.jpg?v=1739342371",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393197239,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£1.13</span>/serving)",
            subs_saving_price: "<span class=money>£34.00</span>",
            price: "<span class=money>£34.00</span>",
            
              compare_price: "<span class=money>£49.00</span>",
              saving_price: "<span class=money>£15</span>",
              saving_html: "save " + "31" + "%",
            
            shoppay_price: "<span class=money>£8.50</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87342963_1000x.webp?v=1739342385"
          });
        
          
          
          
          selling_plans.push({
            id: 1393230007,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.71</span>/serving)",
            subs_saving_price: "<span class=money>£21.33</span>",
            price: "<span class=money>£64.00</span>",
            
              compare_price: "<span class=money>£147.00</span>",
              saving_price: "<span class=money>£83</span>",
              saving_html: "save " + "56" + "%",
            
            shoppay_price: "<span class=money>£16.00</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87342963_1000x.webp?v=1739342385"
          });
        
          
          
          
          selling_plans.push({
            id: 1393262775,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.60</span>/serving)",
            subs_saving_price: "<span class=money>£18.16</span>",
            price: "<span class=money>£109.00</span>",
            
              compare_price: "<span class=money>£294.00</span>",
              saving_price: "<span class=money>£185</span>",
              saving_html: "save " + "63" + "%",
            
            shoppay_price: "<span class=money>£27.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87342963_1000x.webp?v=1739342385"
          });
        
        var options = '';
        
          options += 'Coffee';
          
            options += ',';
          
        
          options += '1x bag | no accessories';
          
        
        variantInfo.push({
          id: 43654517424311,
          options,
          title: "Coffee / 1x bag | no accessories",
          price: "<span class=money>£49.00</span>",
          compare_price: "",
          shoppay_price: "<span class=money>£12.25</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87342963_1000x.webp?v=1739342385",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393295543,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.90</span>/serving)",
            subs_saving_price: "<span class=money>£27.00</span>",
            price: "<span class=money>£54.00</span>",
            
              compare_price: "<span class=money>£98.00</span>",
              saving_price: "<span class=money>£44</span>",
              saving_html: "save " + "45" + "%",
            
            shoppay_price: "<span class=money>£13.50</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343460_1000x.webp?v=1739342402"
          });
        
          
          
          
          selling_plans.push({
            id: 1393328311,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.60</span>/serving)",
            subs_saving_price: "<span class=money>£18.16</span>",
            price: "<span class=money>£109.00</span>",
            
              compare_price: "<span class=money>£294.00</span>",
              saving_price: "<span class=money>£185</span>",
              saving_html: "save " + "63" + "%",
            
            shoppay_price: "<span class=money>£27.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343460_1000x.webp?v=1739342402"
          });
        
          
          
          
          selling_plans.push({
            id: 1393361079,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.58</span>/serving)",
            subs_saving_price: "<span class=money>£17.41</span>",
            price: "<span class=money>£209.00</span>",
            
              compare_price: "<span class=money>£588.00</span>",
              saving_price: "<span class=money>£379</span>",
              saving_html: "save " + "64" + "%",
            
            shoppay_price: "<span class=money>£52.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343460_1000x.webp?v=1739342402"
          });
        
        var options = '';
        
          options += 'Coffee';
          
            options += ',';
          
        
          options += '2x bags | no accessories';
          
        
        variantInfo.push({
          id: 43654517522615,
          options,
          title: "Coffee / 2x bags | no accessories",
          price: "<span class=money>£69.00</span>",
          compare_price: "<span class=money>£98.00</span>",
          shoppay_price: "<span class=money>£17.25</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£29.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343460_1000x.webp?v=1739342402",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393393847,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.76</span>/serving)",
            subs_saving_price: "<span class=money>£23.00</span>",
            price: "<span class=money>£69.00</span>",
            
              compare_price: "<span class=money>£147.00</span>",
              saving_price: "<span class=money>£78</span>",
              saving_html: "save " + "53" + "%",
            
            shoppay_price: "<span class=money>£17.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343591_1000x.webp?v=1739342405"
          });
        
          
          
          
          selling_plans.push({
            id: 1393426615,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.62</span>/serving)",
            subs_saving_price: "<span class=money>£18.77</span>",
            price: "<span class=money>£169.00</span>",
            
              compare_price: "<span class=money>£441.00</span>",
              saving_price: "<span class=money>£272</span>",
              saving_html: "save " + "62" + "%",
            
            shoppay_price: "<span class=money>£42.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343591_1000x.webp?v=1739342405"
          });
        
          
          
          
          selling_plans.push({
            id: 1393459383,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.60</span>/serving)",
            subs_saving_price: "<span class=money>£18.27</span>",
            price: "<span class=money>£329.00</span>",
            
              compare_price: "<span class=money>£882.00</span>",
              saving_price: "<span class=money>£553</span>",
              saving_html: "save " + "63" + "%",
            
            shoppay_price: "<span class=money>£82.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343591_1000x.webp?v=1739342405"
          });
        
        var options = '';
        
          options += 'Coffee';
          
            options += ',';
          
        
          options += '3x bags | no accessories';
          
        
        variantInfo.push({
          id: 43654517620919,
          options,
          title: "Coffee / 3x bags | no accessories",
          price: "<span class=money>£89.00</span>",
          compare_price: "<span class=money>£147.00</span>",
          shoppay_price: "<span class=money>£22.25</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£58.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343591_1000x.webp?v=1739342405",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1392902327,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£1.30</span>/serving)",
            subs_saving_price: "<span class=money>£39.00</span>",
            price: "<span class=money>£39.00</span>",
            
              compare_price: "<span class=money>£125.00</span>",
              saving_price: "<span class=money>£86</span>",
              saving_html: "save " + "69" + "%",
            
            shoppay_price: "<span class=money>£9.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412079_1000x.webp?v=1739342336"
          });
        
          
          
          
          selling_plans.push({
            id: 1392935095,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.76</span>/serving)",
            subs_saving_price: "<span class=money>£23.00</span>",
            price: "<span class=money>£69.00</span>",
            
              compare_price: "<span class=money>£223.00</span>",
              saving_price: "<span class=money>£154</span>",
              saving_html: "save " + "69" + "%",
            
            shoppay_price: "<span class=money>£17.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412079_1000x.webp?v=1739342336"
          });
        
          
          
          
          selling_plans.push({
            id: 1392967863,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.66</span>/serving)",
            subs_saving_price: "<span class=money>£19.83</span>",
            price: "<span class=money>£119.00</span>",
            
              compare_price: "<span class=money>£370.00</span>",
              saving_price: "<span class=money>£251</span>",
              saving_html: "save " + "68" + "%",
            
            shoppay_price: "<span class=money>£29.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412079_1000x.webp?v=1739342336"
          });
        
        var options = '';
        
          options += 'Vanilla Cinnamon';
          
            options += ',';
          
        
          options += '1x bag + free accessories with 1st order';
          
        
        variantInfo.push({
          id: 43654517719223,
          options,
          title: "Vanilla Cinnamon / 1x bag + free accessories with 1st order",
          price: "<span class=money>£39.00</span>",
          compare_price: "<span class=money>£125.00</span>",
          shoppay_price: "<span class=money>£9.75</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£86.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412079_1000x.webp?v=1739342336",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393000631,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.98</span>/serving)",
            subs_saving_price: "<span class=money>£29.50</span>",
            price: "<span class=money>£59.00</span>",
            
              compare_price: "<span class=money>£193.00</span>",
              saving_price: "<span class=money>£134</span>",
              saving_html: "save " + "69" + "%",
            
            shoppay_price: "<span class=money>£14.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89407595_1000x.webp?v=1739342344"
          });
        
          
          
          
          selling_plans.push({
            id: 1393033399,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.71</span>/serving)",
            subs_saving_price: "<span class=money>£21.50</span>",
            price: "<span class=money>£129.00</span>",
            
              compare_price: "<span class=money>£370.00</span>",
              saving_price: "<span class=money>£241</span>",
              saving_html: "save " + "65" + "%",
            
            shoppay_price: "<span class=money>£32.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89407595_1000x.webp?v=1739342344"
          });
        
          
          
          
          selling_plans.push({
            id: 1393066167,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.63</span>/serving)",
            subs_saving_price: "<span class=money>£19.08</span>",
            price: "<span class=money>£229.00</span>",
            
              compare_price: "<span class=money>£664.00</span>",
              saving_price: "<span class=money>£435</span>",
              saving_html: "save " + "66" + "%",
            
            shoppay_price: "<span class=money>£57.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89407595_1000x.webp?v=1739342344"
          });
        
        var options = '';
        
          options += 'Vanilla Cinnamon';
          
            options += ',';
          
        
          options += '2x bags + free accessories with 1st order';
          
        
        variantInfo.push({
          id: 43654517817527,
          options,
          title: "Vanilla Cinnamon / 2x bags + free accessories with 1st order",
          price: "<span class=money>£59.00</span>",
          compare_price: "<span class=money>£193.00</span>",
          shoppay_price: "<span class=money>£14.75</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£134.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89407595_1000x.webp?v=1739342344",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393098935,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.82</span>/serving)",
            subs_saving_price: "<span class=money>£24.66</span>",
            price: "<span class=money>£74.00</span>",
            
              compare_price: "<span class=money>£261.00</span>",
              saving_price: "<span class=money>£187</span>",
              saving_html: "save " + "72" + "%",
            
            shoppay_price: "<span class=money>£18.50</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354573_1000x.jpg?v=1739342368"
          });
        
          
          
          
          selling_plans.push({
            id: 1393131703,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.66</span>/serving)",
            subs_saving_price: "<span class=money>£19.88</span>",
            price: "<span class=money>£179.00</span>",
            
              compare_price: "<span class=money>£517.00</span>",
              saving_price: "<span class=money>£338</span>",
              saving_html: "save " + "65" + "%",
            
            shoppay_price: "<span class=money>£44.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354573_1000x.jpg?v=1739342368"
          });
        
          
          
          
          selling_plans.push({
            id: 1393164471,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.62</span>/serving)",
            subs_saving_price: "<span class=money>£18.83</span>",
            price: "<span class=money>£339.00</span>",
            
              compare_price: "<span class=money>£958.00</span>",
              saving_price: "<span class=money>£619</span>",
              saving_html: "save " + "65" + "%",
            
            shoppay_price: "<span class=money>£84.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354573_1000x.jpg?v=1739342368"
          });
        
        var options = '';
        
          options += 'Vanilla Cinnamon';
          
            options += ',';
          
        
          options += '3x bags + free accessories with 1st order';
          
        
        variantInfo.push({
          id: 43654517915831,
          options,
          title: "Vanilla Cinnamon / 3x bags + free accessories with 1st order",
          price: "<span class=money>£74.00</span>",
          compare_price: "<span class=money>£261.00</span>",
          shoppay_price: "<span class=money>£18.50</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£187.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354573_1000x.jpg?v=1739342368",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393197239,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£1.13</span>/serving)",
            subs_saving_price: "<span class=money>£34.00</span>",
            price: "<span class=money>£34.00</span>",
            
              compare_price: "<span class=money>£49.00</span>",
              saving_price: "<span class=money>£15</span>",
              saving_html: "save " + "31" + "%",
            
            shoppay_price: "<span class=money>£8.50</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343079_1000x.jpg?v=1739342388"
          });
        
          
          
          
          selling_plans.push({
            id: 1393230007,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.71</span>/serving)",
            subs_saving_price: "<span class=money>£21.33</span>",
            price: "<span class=money>£64.00</span>",
            
              compare_price: "<span class=money>£147.00</span>",
              saving_price: "<span class=money>£83</span>",
              saving_html: "save " + "56" + "%",
            
            shoppay_price: "<span class=money>£16.00</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343079_1000x.jpg?v=1739342388"
          });
        
          
          
          
          selling_plans.push({
            id: 1393262775,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.60</span>/serving)",
            subs_saving_price: "<span class=money>£18.16</span>",
            price: "<span class=money>£109.00</span>",
            
              compare_price: "<span class=money>£294.00</span>",
              saving_price: "<span class=money>£185</span>",
              saving_html: "save " + "63" + "%",
            
            shoppay_price: "<span class=money>£27.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343079_1000x.jpg?v=1739342388"
          });
        
        var options = '';
        
          options += 'Vanilla Cinnamon';
          
            options += ',';
          
        
          options += '1x bag | no accessories';
          
        
        variantInfo.push({
          id: 43654518046903,
          options,
          title: "Vanilla Cinnamon / 1x bag | no accessories",
          price: "<span class=money>£49.00</span>",
          compare_price: "",
          shoppay_price: "<span class=money>£12.25</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343079_1000x.jpg?v=1739342388",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393295543,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.90</span>/serving)",
            subs_saving_price: "<span class=money>£27.00</span>",
            price: "<span class=money>£54.00</span>",
            
              compare_price: "<span class=money>£98.00</span>",
              saving_price: "<span class=money>£44</span>",
              saving_html: "save " + "45" + "%",
            
            shoppay_price: "<span class=money>£13.50</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343697_1000x.webp?v=1739342408"
          });
        
          
          
          
          selling_plans.push({
            id: 1393328311,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.60</span>/serving)",
            subs_saving_price: "<span class=money>£18.16</span>",
            price: "<span class=money>£109.00</span>",
            
              compare_price: "<span class=money>£294.00</span>",
              saving_price: "<span class=money>£185</span>",
              saving_html: "save " + "63" + "%",
            
            shoppay_price: "<span class=money>£27.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343697_1000x.webp?v=1739342408"
          });
        
          
          
          
          selling_plans.push({
            id: 1393361079,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.58</span>/serving)",
            subs_saving_price: "<span class=money>£17.41</span>",
            price: "<span class=money>£209.00</span>",
            
              compare_price: "<span class=money>£588.00</span>",
              saving_price: "<span class=money>£379</span>",
              saving_html: "save " + "64" + "%",
            
            shoppay_price: "<span class=money>£52.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343697_1000x.webp?v=1739342408"
          });
        
        var options = '';
        
          options += 'Vanilla Cinnamon';
          
            options += ',';
          
        
          options += '2x bags | no accessories';
          
        
        variantInfo.push({
          id: 43654518145207,
          options,
          title: "Vanilla Cinnamon / 2x bags | no accessories",
          price: "<span class=money>£69.00</span>",
          compare_price: "<span class=money>£98.00</span>",
          shoppay_price: "<span class=money>£17.25</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£29.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343697_1000x.webp?v=1739342408",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393393847,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.76</span>/serving)",
            subs_saving_price: "<span class=money>£23.00</span>",
            price: "<span class=money>£69.00</span>",
            
              compare_price: "<span class=money>£147.00</span>",
              saving_price: "<span class=money>£78</span>",
              saving_html: "save " + "53" + "%",
            
            shoppay_price: "<span class=money>£17.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343750_1000x.webp?v=1739342411"
          });
        
          
          
          
          selling_plans.push({
            id: 1393426615,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.62</span>/serving)",
            subs_saving_price: "<span class=money>£18.77</span>",
            price: "<span class=money>£169.00</span>",
            
              compare_price: "<span class=money>£441.00</span>",
              saving_price: "<span class=money>£272</span>",
              saving_html: "save " + "62" + "%",
            
            shoppay_price: "<span class=money>£42.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343750_1000x.webp?v=1739342411"
          });
        
          
          
          
          selling_plans.push({
            id: 1393459383,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.60</span>/serving)",
            subs_saving_price: "<span class=money>£18.27</span>",
            price: "<span class=money>£329.00</span>",
            
              compare_price: "<span class=money>£882.00</span>",
              saving_price: "<span class=money>£553</span>",
              saving_html: "save " + "63" + "%",
            
            shoppay_price: "<span class=money>£82.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343750_1000x.webp?v=1739342411"
          });
        
        var options = '';
        
          options += 'Vanilla Cinnamon';
          
            options += ',';
          
        
          options += '3x bags | no accessories';
          
        
        variantInfo.push({
          id: 43654518243511,
          options,
          title: "Vanilla Cinnamon / 3x bags | no accessories",
          price: "<span class=money>£89.00</span>",
          compare_price: "<span class=money>£147.00</span>",
          shoppay_price: "<span class=money>£22.25</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£58.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343750_1000x.webp?v=1739342411",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1392902327,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£1.30</span>/serving)",
            subs_saving_price: "<span class=money>£39.00</span>",
            price: "<span class=money>£39.00</span>",
            
              compare_price: "<span class=money>£125.00</span>",
              saving_price: "<span class=money>£86</span>",
              saving_html: "save " + "69" + "%",
            
            shoppay_price: "<span class=money>£9.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89353589_1000x.jpg?v=1739342331"
          });
        
          
          
          
          selling_plans.push({
            id: 1392935095,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.76</span>/serving)",
            subs_saving_price: "<span class=money>£23.00</span>",
            price: "<span class=money>£69.00</span>",
            
              compare_price: "<span class=money>£223.00</span>",
              saving_price: "<span class=money>£154</span>",
              saving_html: "save " + "69" + "%",
            
            shoppay_price: "<span class=money>£17.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89353589_1000x.jpg?v=1739342331"
          });
        
          
          
          
          selling_plans.push({
            id: 1392967863,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.66</span>/serving)",
            subs_saving_price: "<span class=money>£19.83</span>",
            price: "<span class=money>£119.00</span>",
            
              compare_price: "<span class=money>£370.00</span>",
              saving_price: "<span class=money>£251</span>",
              saving_html: "save " + "68" + "%",
            
            shoppay_price: "<span class=money>£29.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89353589_1000x.jpg?v=1739342331"
          });
        
        var options = '';
        
          options += 'Chocolate';
          
            options += ',';
          
        
          options += '1x bag + free accessories with 1st order';
          
        
        variantInfo.push({
          id: 43654518341815,
          options,
          title: "Chocolate / 1x bag + free accessories with 1st order",
          price: "<span class=money>£39.00</span>",
          compare_price: "<span class=money>£125.00</span>",
          shoppay_price: "<span class=money>£9.75</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£86.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89353589_1000x.jpg?v=1739342331",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393000631,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.98</span>/serving)",
            subs_saving_price: "<span class=money>£29.50</span>",
            price: "<span class=money>£59.00</span>",
            
              compare_price: "<span class=money>£193.00</span>",
              saving_price: "<span class=money>£134</span>",
              saving_html: "save " + "69" + "%",
            
            shoppay_price: "<span class=money>£14.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89413238_1000x.jpg?v=1739342447"
          });
        
          
          
          
          selling_plans.push({
            id: 1393033399,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.71</span>/serving)",
            subs_saving_price: "<span class=money>£21.50</span>",
            price: "<span class=money>£129.00</span>",
            
              compare_price: "<span class=money>£370.00</span>",
              saving_price: "<span class=money>£241</span>",
              saving_html: "save " + "65" + "%",
            
            shoppay_price: "<span class=money>£32.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89413238_1000x.jpg?v=1739342447"
          });
        
          
          
          
          selling_plans.push({
            id: 1393066167,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.63</span>/serving)",
            subs_saving_price: "<span class=money>£19.08</span>",
            price: "<span class=money>£229.00</span>",
            
              compare_price: "<span class=money>£664.00</span>",
              saving_price: "<span class=money>£435</span>",
              saving_html: "save " + "66" + "%",
            
            shoppay_price: "<span class=money>£57.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89413238_1000x.jpg?v=1739342447"
          });
        
        var options = '';
        
          options += 'Chocolate';
          
            options += ',';
          
        
          options += '2x bags + free accessories with 1st order';
          
        
        variantInfo.push({
          id: 43654518440119,
          options,
          title: "Chocolate / 2x bags + free accessories with 1st order",
          price: "<span class=money>£59.00</span>",
          compare_price: "<span class=money>£193.00</span>",
          shoppay_price: "<span class=money>£14.75</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£134.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89413238_1000x.jpg?v=1739342447",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393098935,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.82</span>/serving)",
            subs_saving_price: "<span class=money>£24.66</span>",
            price: "<span class=money>£74.00</span>",
            
              compare_price: "<span class=money>£261.00</span>",
              saving_price: "<span class=money>£187</span>",
              saving_html: "save " + "72" + "%",
            
            shoppay_price: "<span class=money>£18.50</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354371_1000x.jpg?v=1739342359"
          });
        
          
          
          
          selling_plans.push({
            id: 1393131703,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.66</span>/serving)",
            subs_saving_price: "<span class=money>£19.88</span>",
            price: "<span class=money>£179.00</span>",
            
              compare_price: "<span class=money>£517.00</span>",
              saving_price: "<span class=money>£338</span>",
              saving_html: "save " + "65" + "%",
            
            shoppay_price: "<span class=money>£44.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354371_1000x.jpg?v=1739342359"
          });
        
          
          
          
          selling_plans.push({
            id: 1393164471,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.62</span>/serving)",
            subs_saving_price: "<span class=money>£18.83</span>",
            price: "<span class=money>£339.00</span>",
            
              compare_price: "<span class=money>£958.00</span>",
              saving_price: "<span class=money>£619</span>",
              saving_html: "save " + "65" + "%",
            
            shoppay_price: "<span class=money>£84.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354371_1000x.jpg?v=1739342359"
          });
        
        var options = '';
        
          options += 'Chocolate';
          
            options += ',';
          
        
          options += '3x bags + free accessories with 1st order';
          
        
        variantInfo.push({
          id: 43654518538423,
          options,
          title: "Chocolate / 3x bags + free accessories with 1st order",
          price: "<span class=money>£74.00</span>",
          compare_price: "<span class=money>£261.00</span>",
          shoppay_price: "<span class=money>£18.50</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£187.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354371_1000x.jpg?v=1739342359",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393197239,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£1.13</span>/serving)",
            subs_saving_price: "<span class=money>£34.00</span>",
            price: "<span class=money>£34.00</span>",
            
              compare_price: "<span class=money>£49.00</span>",
              saving_price: "<span class=money>£15</span>",
              saving_html: "save " + "31" + "%",
            
            shoppay_price: "<span class=money>£8.50</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343153_1000x.webp?v=1739342391"
          });
        
          
          
          
          selling_plans.push({
            id: 1393230007,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.71</span>/serving)",
            subs_saving_price: "<span class=money>£21.33</span>",
            price: "<span class=money>£64.00</span>",
            
              compare_price: "<span class=money>£147.00</span>",
              saving_price: "<span class=money>£83</span>",
              saving_html: "save " + "56" + "%",
            
            shoppay_price: "<span class=money>£16.00</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343153_1000x.webp?v=1739342391"
          });
        
          
          
          
          selling_plans.push({
            id: 1393262775,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.60</span>/serving)",
            subs_saving_price: "<span class=money>£18.16</span>",
            price: "<span class=money>£109.00</span>",
            
              compare_price: "<span class=money>£294.00</span>",
              saving_price: "<span class=money>£185</span>",
              saving_html: "save " + "63" + "%",
            
            shoppay_price: "<span class=money>£27.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343153_1000x.webp?v=1739342391"
          });
        
        var options = '';
        
          options += 'Chocolate';
          
            options += ',';
          
        
          options += '1x bag | no accessories';
          
        
        variantInfo.push({
          id: 43654518669495,
          options,
          title: "Chocolate / 1x bag | no accessories",
          price: "<span class=money>£49.00</span>",
          compare_price: "",
          shoppay_price: "<span class=money>£12.25</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343153_1000x.webp?v=1739342391",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393295543,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.90</span>/serving)",
            subs_saving_price: "<span class=money>£27.00</span>",
            price: "<span class=money>£54.00</span>",
            
              compare_price: "<span class=money>£98.00</span>",
              saving_price: "<span class=money>£44</span>",
              saving_html: "save " + "45" + "%",
            
            shoppay_price: "<span class=money>£13.50</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343874_1000x.webp?v=1739342412"
          });
        
          
          
          
          selling_plans.push({
            id: 1393328311,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.60</span>/serving)",
            subs_saving_price: "<span class=money>£18.16</span>",
            price: "<span class=money>£109.00</span>",
            
              compare_price: "<span class=money>£294.00</span>",
              saving_price: "<span class=money>£185</span>",
              saving_html: "save " + "63" + "%",
            
            shoppay_price: "<span class=money>£27.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343874_1000x.webp?v=1739342412"
          });
        
          
          
          
          selling_plans.push({
            id: 1393361079,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.58</span>/serving)",
            subs_saving_price: "<span class=money>£17.41</span>",
            price: "<span class=money>£209.00</span>",
            
              compare_price: "<span class=money>£588.00</span>",
              saving_price: "<span class=money>£379</span>",
              saving_html: "save " + "64" + "%",
            
            shoppay_price: "<span class=money>£52.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343874_1000x.webp?v=1739342412"
          });
        
        var options = '';
        
          options += 'Chocolate';
          
            options += ',';
          
        
          options += '2x bags | no accessories';
          
        
        variantInfo.push({
          id: 43654518800567,
          options,
          title: "Chocolate / 2x bags | no accessories",
          price: "<span class=money>£69.00</span>",
          compare_price: "<span class=money>£98.00</span>",
          shoppay_price: "<span class=money>£17.25</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£29.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343874_1000x.webp?v=1739342412",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393393847,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.76</span>/serving)",
            subs_saving_price: "<span class=money>£23.00</span>",
            price: "<span class=money>£69.00</span>",
            
              compare_price: "<span class=money>£147.00</span>",
              saving_price: "<span class=money>£78</span>",
              saving_html: "save " + "53" + "%",
            
            shoppay_price: "<span class=money>£17.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343918_1000x.webp?v=1739342415"
          });
        
          
          
          
          selling_plans.push({
            id: 1393426615,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.62</span>/serving)",
            subs_saving_price: "<span class=money>£18.77</span>",
            price: "<span class=money>£169.00</span>",
            
              compare_price: "<span class=money>£441.00</span>",
              saving_price: "<span class=money>£272</span>",
              saving_html: "save " + "62" + "%",
            
            shoppay_price: "<span class=money>£42.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343918_1000x.webp?v=1739342415"
          });
        
          
          
          
          selling_plans.push({
            id: 1393459383,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.60</span>/serving)",
            subs_saving_price: "<span class=money>£18.27</span>",
            price: "<span class=money>£329.00</span>",
            
              compare_price: "<span class=money>£882.00</span>",
              saving_price: "<span class=money>£553</span>",
              saving_html: "save " + "63" + "%",
            
            shoppay_price: "<span class=money>£82.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343918_1000x.webp?v=1739342415"
          });
        
        var options = '';
        
          options += 'Chocolate';
          
            options += ',';
          
        
          options += '3x bags | no accessories';
          
        
        variantInfo.push({
          id: 43654518898871,
          options,
          title: "Chocolate / 3x bags | no accessories",
          price: "<span class=money>£89.00</span>",
          compare_price: "<span class=money>£147.00</span>",
          shoppay_price: "<span class=money>£22.25</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£58.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343918_1000x.webp?v=1739342415",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1392902327,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£1.30</span>/serving)",
            subs_saving_price: "<span class=money>£39.00</span>",
            price: "<span class=money>£39.00</span>",
            
              compare_price: "<span class=money>£125.00</span>",
              saving_price: "<span class=money>£86</span>",
              saving_html: "save " + "69" + "%",
            
            shoppay_price: "<span class=money>£9.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89353695_1000x.jpg?v=1739342334"
          });
        
          
          
          
          selling_plans.push({
            id: 1392935095,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.76</span>/serving)",
            subs_saving_price: "<span class=money>£23.00</span>",
            price: "<span class=money>£69.00</span>",
            
              compare_price: "<span class=money>£223.00</span>",
              saving_price: "<span class=money>£154</span>",
              saving_html: "save " + "69" + "%",
            
            shoppay_price: "<span class=money>£17.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89353695_1000x.jpg?v=1739342334"
          });
        
          
          
          
          selling_plans.push({
            id: 1392967863,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.66</span>/serving)",
            subs_saving_price: "<span class=money>£19.83</span>",
            price: "<span class=money>£119.00</span>",
            
              compare_price: "<span class=money>£370.00</span>",
              saving_price: "<span class=money>£251</span>",
              saving_html: "save " + "68" + "%",
            
            shoppay_price: "<span class=money>£29.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89353695_1000x.jpg?v=1739342334"
          });
        
        var options = '';
        
          options += 'Strawberry';
          
            options += ',';
          
        
          options += '1x bag + free accessories with 1st order';
          
        
        variantInfo.push({
          id: 43654518997175,
          options,
          title: "Strawberry / 1x bag + free accessories with 1st order",
          price: "<span class=money>£39.00</span>",
          compare_price: "<span class=money>£125.00</span>",
          shoppay_price: "<span class=money>£9.75</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£86.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89353695_1000x.jpg?v=1739342334",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393000631,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.98</span>/serving)",
            subs_saving_price: "<span class=money>£29.50</span>",
            price: "<span class=money>£59.00</span>",
            
              compare_price: "<span class=money>£193.00</span>",
              saving_price: "<span class=money>£134</span>",
              saving_html: "save " + "69" + "%",
            
            shoppay_price: "<span class=money>£14.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89407839_1000x.webp?v=1739342353"
          });
        
          
          
          
          selling_plans.push({
            id: 1393033399,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.71</span>/serving)",
            subs_saving_price: "<span class=money>£21.50</span>",
            price: "<span class=money>£129.00</span>",
            
              compare_price: "<span class=money>£370.00</span>",
              saving_price: "<span class=money>£241</span>",
              saving_html: "save " + "65" + "%",
            
            shoppay_price: "<span class=money>£32.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89407839_1000x.webp?v=1739342353"
          });
        
          
          
          
          selling_plans.push({
            id: 1393066167,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.63</span>/serving)",
            subs_saving_price: "<span class=money>£19.08</span>",
            price: "<span class=money>£229.00</span>",
            
              compare_price: "<span class=money>£664.00</span>",
              saving_price: "<span class=money>£435</span>",
              saving_html: "save " + "66" + "%",
            
            shoppay_price: "<span class=money>£57.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89407839_1000x.webp?v=1739342353"
          });
        
        var options = '';
        
          options += 'Strawberry';
          
            options += ',';
          
        
          options += '2x bags + free accessories with 1st order';
          
        
        variantInfo.push({
          id: 43654519095479,
          options,
          title: "Strawberry / 2x bags + free accessories with 1st order",
          price: "<span class=money>£59.00</span>",
          compare_price: "<span class=money>£193.00</span>",
          shoppay_price: "<span class=money>£14.75</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£134.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89407839_1000x.webp?v=1739342353",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393098935,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.82</span>/serving)",
            subs_saving_price: "<span class=money>£24.66</span>",
            price: "<span class=money>£74.00</span>",
            
              compare_price: "<span class=money>£261.00</span>",
              saving_price: "<span class=money>£187</span>",
              saving_html: "save " + "72" + "%",
            
            shoppay_price: "<span class=money>£18.50</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354445_1000x.jpg?v=1739342365"
          });
        
          
          
          
          selling_plans.push({
            id: 1393131703,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.66</span>/serving)",
            subs_saving_price: "<span class=money>£19.88</span>",
            price: "<span class=money>£179.00</span>",
            
              compare_price: "<span class=money>£517.00</span>",
              saving_price: "<span class=money>£338</span>",
              saving_html: "save " + "65" + "%",
            
            shoppay_price: "<span class=money>£44.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354445_1000x.jpg?v=1739342365"
          });
        
          
          
          
          selling_plans.push({
            id: 1393164471,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.62</span>/serving)",
            subs_saving_price: "<span class=money>£18.83</span>",
            price: "<span class=money>£339.00</span>",
            
              compare_price: "<span class=money>£958.00</span>",
              saving_price: "<span class=money>£619</span>",
              saving_html: "save " + "65" + "%",
            
            shoppay_price: "<span class=money>£84.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354445_1000x.jpg?v=1739342365"
          });
        
        var options = '';
        
          options += 'Strawberry';
          
            options += ',';
          
        
          options += '3x bags + free accessories with 1st order';
          
        
        variantInfo.push({
          id: 43654519226551,
          options,
          title: "Strawberry / 3x bags + free accessories with 1st order",
          price: "<span class=money>£74.00</span>",
          compare_price: "<span class=money>£261.00</span>",
          shoppay_price: "<span class=money>£18.50</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£187.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89354445_1000x.jpg?v=1739342365",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393197239,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£1.13</span>/serving)",
            subs_saving_price: "<span class=money>£34.00</span>",
            price: "<span class=money>£34.00</span>",
            
              compare_price: "<span class=money>£49.00</span>",
              saving_price: "<span class=money>£15</span>",
              saving_html: "save " + "31" + "%",
            
            shoppay_price: "<span class=money>£8.50</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343283_1000x.webp?v=1739342394"
          });
        
          
          
          
          selling_plans.push({
            id: 1393230007,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.71</span>/serving)",
            subs_saving_price: "<span class=money>£21.33</span>",
            price: "<span class=money>£64.00</span>",
            
              compare_price: "<span class=money>£147.00</span>",
              saving_price: "<span class=money>£83</span>",
              saving_html: "save " + "56" + "%",
            
            shoppay_price: "<span class=money>£16.00</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343283_1000x.webp?v=1739342394"
          });
        
          
          
          
          selling_plans.push({
            id: 1393262775,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.60</span>/serving)",
            subs_saving_price: "<span class=money>£18.16</span>",
            price: "<span class=money>£109.00</span>",
            
              compare_price: "<span class=money>£294.00</span>",
              saving_price: "<span class=money>£185</span>",
              saving_html: "save " + "63" + "%",
            
            shoppay_price: "<span class=money>£27.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343283_1000x.webp?v=1739342394"
          });
        
        var options = '';
        
          options += 'Strawberry';
          
            options += ',';
          
        
          options += '1x bag | no accessories';
          
        
        variantInfo.push({
          id: 43654519324855,
          options,
          title: "Strawberry / 1x bag | no accessories",
          price: "<span class=money>£49.00</span>",
          compare_price: "",
          shoppay_price: "<span class=money>£12.25</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343283_1000x.webp?v=1739342394",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393295543,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.90</span>/serving)",
            subs_saving_price: "<span class=money>£27.00</span>",
            price: "<span class=money>£54.00</span>",
            
              compare_price: "<span class=money>£98.00</span>",
              saving_price: "<span class=money>£44</span>",
              saving_html: "save " + "45" + "%",
            
            shoppay_price: "<span class=money>£13.50</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344029_1000x.webp?v=1739342420"
          });
        
          
          
          
          selling_plans.push({
            id: 1393328311,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.60</span>/serving)",
            subs_saving_price: "<span class=money>£18.16</span>",
            price: "<span class=money>£109.00</span>",
            
              compare_price: "<span class=money>£294.00</span>",
              saving_price: "<span class=money>£185</span>",
              saving_html: "save " + "63" + "%",
            
            shoppay_price: "<span class=money>£27.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344029_1000x.webp?v=1739342420"
          });
        
          
          
          
          selling_plans.push({
            id: 1393361079,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.58</span>/serving)",
            subs_saving_price: "<span class=money>£17.41</span>",
            price: "<span class=money>£209.00</span>",
            
              compare_price: "<span class=money>£588.00</span>",
              saving_price: "<span class=money>£379</span>",
              saving_html: "save " + "64" + "%",
            
            shoppay_price: "<span class=money>£52.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344029_1000x.webp?v=1739342420"
          });
        
        var options = '';
        
          options += 'Strawberry';
          
            options += ',';
          
        
          options += '2x bags | no accessories';
          
        
        variantInfo.push({
          id: 43654519423159,
          options,
          title: "Strawberry / 2x bags | no accessories",
          price: "<span class=money>£69.00</span>",
          compare_price: "<span class=money>£98.00</span>",
          shoppay_price: "<span class=money>£17.25</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£29.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344029_1000x.webp?v=1739342420",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393393847,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.76</span>/serving)",
            subs_saving_price: "<span class=money>£23.00</span>",
            price: "<span class=money>£69.00</span>",
            
              compare_price: "<span class=money>£147.00</span>",
              saving_price: "<span class=money>£78</span>",
              saving_html: "save " + "53" + "%",
            
            shoppay_price: "<span class=money>£17.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344161_1000x.webp?v=1739342424"
          });
        
          
          
          
          selling_plans.push({
            id: 1393426615,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.62</span>/serving)",
            subs_saving_price: "<span class=money>£18.77</span>",
            price: "<span class=money>£169.00</span>",
            
              compare_price: "<span class=money>£441.00</span>",
              saving_price: "<span class=money>£272</span>",
              saving_html: "save " + "62" + "%",
            
            shoppay_price: "<span class=money>£42.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344161_1000x.webp?v=1739342424"
          });
        
          
          
          
          selling_plans.push({
            id: 1393459383,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.60</span>/serving)",
            subs_saving_price: "<span class=money>£18.27</span>",
            price: "<span class=money>£329.00</span>",
            
              compare_price: "<span class=money>£882.00</span>",
              saving_price: "<span class=money>£553</span>",
              saving_html: "save " + "63" + "%",
            
            shoppay_price: "<span class=money>£82.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344161_1000x.webp?v=1739342424"
          });
        
        var options = '';
        
          options += 'Strawberry';
          
            options += ',';
          
        
          options += '3x bags | no accessories';
          
        
        variantInfo.push({
          id: 43654519521463,
          options,
          title: "Strawberry / 3x bags | no accessories",
          price: "<span class=money>£89.00</span>",
          compare_price: "<span class=money>£147.00</span>",
          shoppay_price: "<span class=money>£22.25</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£58.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344161_1000x.webp?v=1739342424",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1392902327,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£1.30</span>/serving)",
            subs_saving_price: "<span class=money>£39.00</span>",
            price: "<span class=money>£39.00</span>",
            
              compare_price: "<span class=money>£125.00</span>",
              saving_price: "<span class=money>£86</span>",
              saving_html: "save " + "69" + "%",
            
            shoppay_price: "<span class=money>£9.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412140_1000x.webp?v=1739342340"
          });
        
          
          
          
          selling_plans.push({
            id: 1392935095,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.76</span>/serving)",
            subs_saving_price: "<span class=money>£23.00</span>",
            price: "<span class=money>£69.00</span>",
            
              compare_price: "<span class=money>£223.00</span>",
              saving_price: "<span class=money>£154</span>",
              saving_html: "save " + "69" + "%",
            
            shoppay_price: "<span class=money>£17.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412140_1000x.webp?v=1739342340"
          });
        
          
          
          
          selling_plans.push({
            id: 1392967863,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.66</span>/serving)",
            subs_saving_price: "<span class=money>£19.83</span>",
            price: "<span class=money>£119.00</span>",
            
              compare_price: "<span class=money>£370.00</span>",
              saving_price: "<span class=money>£251</span>",
              saving_html: "save " + "68" + "%",
            
            shoppay_price: "<span class=money>£29.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412140_1000x.webp?v=1739342340"
          });
        
        var options = '';
        
          options += 'Raw Chocolate (Decaf)';
          
            options += ',';
          
        
          options += '1x bag + free accessories with 1st order';
          
        
        variantInfo.push({
          id: 43654519619767,
          options,
          title: "Raw Chocolate (Decaf) / 1x bag + free accessories with 1st order",
          price: "<span class=money>£39.00</span>",
          compare_price: "<span class=money>£125.00</span>",
          shoppay_price: "<span class=money>£9.75</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£86.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412140_1000x.webp?v=1739342340",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393000631,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.98</span>/serving)",
            subs_saving_price: "<span class=money>£29.50</span>",
            price: "<span class=money>£59.00</span>",
            
              compare_price: "<span class=money>£193.00</span>",
              saving_price: "<span class=money>£134</span>",
              saving_html: "save " + "69" + "%",
            
            shoppay_price: "<span class=money>£14.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412275_1000x.webp?v=1739342355"
          });
        
          
          
          
          selling_plans.push({
            id: 1393033399,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.71</span>/serving)",
            subs_saving_price: "<span class=money>£21.50</span>",
            price: "<span class=money>£129.00</span>",
            
              compare_price: "<span class=money>£370.00</span>",
              saving_price: "<span class=money>£241</span>",
              saving_html: "save " + "65" + "%",
            
            shoppay_price: "<span class=money>£32.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412275_1000x.webp?v=1739342355"
          });
        
          
          
          
          selling_plans.push({
            id: 1393066167,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.63</span>/serving)",
            subs_saving_price: "<span class=money>£19.08</span>",
            price: "<span class=money>£229.00</span>",
            
              compare_price: "<span class=money>£664.00</span>",
              saving_price: "<span class=money>£435</span>",
              saving_html: "save " + "66" + "%",
            
            shoppay_price: "<span class=money>£57.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412275_1000x.webp?v=1739342355"
          });
        
        var options = '';
        
          options += 'Raw Chocolate (Decaf)';
          
            options += ',';
          
        
          options += '2x bags + free accessories with 1st order';
          
        
        variantInfo.push({
          id: 43654519750839,
          options,
          title: "Raw Chocolate (Decaf) / 2x bags + free accessories with 1st order",
          price: "<span class=money>£59.00</span>",
          compare_price: "<span class=money>£193.00</span>",
          shoppay_price: "<span class=money>£14.75</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£134.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412275_1000x.webp?v=1739342355",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393098935,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.82</span>/serving)",
            subs_saving_price: "<span class=money>£24.66</span>",
            price: "<span class=money>£74.00</span>",
            
              compare_price: "<span class=money>£261.00</span>",
              saving_price: "<span class=money>£187</span>",
              saving_html: "save " + "72" + "%",
            
            shoppay_price: "<span class=money>£18.50</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412370_1000x.webp?v=1739342361"
          });
        
          
          
          
          selling_plans.push({
            id: 1393131703,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.66</span>/serving)",
            subs_saving_price: "<span class=money>£19.88</span>",
            price: "<span class=money>£179.00</span>",
            
              compare_price: "<span class=money>£517.00</span>",
              saving_price: "<span class=money>£338</span>",
              saving_html: "save " + "65" + "%",
            
            shoppay_price: "<span class=money>£44.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412370_1000x.webp?v=1739342361"
          });
        
          
          
          
          selling_plans.push({
            id: 1393164471,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.62</span>/serving)",
            subs_saving_price: "<span class=money>£18.83</span>",
            price: "<span class=money>£339.00</span>",
            
              compare_price: "<span class=money>£958.00</span>",
              saving_price: "<span class=money>£619</span>",
              saving_html: "save " + "65" + "%",
            
            shoppay_price: "<span class=money>£84.75</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412370_1000x.webp?v=1739342361"
          });
        
        var options = '';
        
          options += 'Raw Chocolate (Decaf)';
          
            options += ',';
          
        
          options += '3x bags + free accessories with 1st order';
          
        
        variantInfo.push({
          id: 43654519849143,
          options,
          title: "Raw Chocolate (Decaf) / 3x bags + free accessories with 1st order",
          price: "<span class=money>£74.00</span>",
          compare_price: "<span class=money>£261.00</span>",
          shoppay_price: "<span class=money>£18.50</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£187.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-89412370_1000x.webp?v=1739342361",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393197239,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£1.13</span>/serving)",
            subs_saving_price: "<span class=money>£34.00</span>",
            price: "<span class=money>£34.00</span>",
            
              compare_price: "<span class=money>£49.00</span>",
              saving_price: "<span class=money>£15</span>",
              saving_html: "save " + "31" + "%",
            
            shoppay_price: "<span class=money>£8.50</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343341_1000x.webp?v=1739342397"
          });
        
          
          
          
          selling_plans.push({
            id: 1393230007,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.71</span>/serving)",
            subs_saving_price: "<span class=money>£21.33</span>",
            price: "<span class=money>£64.00</span>",
            
              compare_price: "<span class=money>£147.00</span>",
              saving_price: "<span class=money>£83</span>",
              saving_html: "save " + "56" + "%",
            
            shoppay_price: "<span class=money>£16.00</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343341_1000x.webp?v=1739342397"
          });
        
          
          
          
          selling_plans.push({
            id: 1393262775,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.60</span>/serving)",
            subs_saving_price: "<span class=money>£18.16</span>",
            price: "<span class=money>£109.00</span>",
            
              compare_price: "<span class=money>£294.00</span>",
              saving_price: "<span class=money>£185</span>",
              saving_html: "save " + "63" + "%",
            
            shoppay_price: "<span class=money>£27.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343341_1000x.webp?v=1739342397"
          });
        
        var options = '';
        
          options += 'Raw Chocolate (Decaf)';
          
            options += ',';
          
        
          options += '1x bag | no accessories';
          
        
        variantInfo.push({
          id: 43654519947447,
          options,
          title: "Raw Chocolate (Decaf) / 1x bag | no accessories",
          price: "<span class=money>£49.00</span>",
          compare_price: "",
          shoppay_price: "<span class=money>£12.25</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87343341_1000x.webp?v=1739342397",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393295543,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.90</span>/serving)",
            subs_saving_price: "<span class=money>£27.00</span>",
            price: "<span class=money>£54.00</span>",
            
              compare_price: "<span class=money>£98.00</span>",
              saving_price: "<span class=money>£44</span>",
              saving_html: "save " + "45" + "%",
            
            shoppay_price: "<span class=money>£13.50</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344275_1000x.webp?v=1739342426"
          });
        
          
          
          
          selling_plans.push({
            id: 1393328311,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.60</span>/serving)",
            subs_saving_price: "<span class=money>£18.16</span>",
            price: "<span class=money>£109.00</span>",
            
              compare_price: "<span class=money>£294.00</span>",
              saving_price: "<span class=money>£185</span>",
              saving_html: "save " + "63" + "%",
            
            shoppay_price: "<span class=money>£27.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344275_1000x.webp?v=1739342426"
          });
        
          
          
          
          selling_plans.push({
            id: 1393361079,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.58</span>/serving)",
            subs_saving_price: "<span class=money>£17.41</span>",
            price: "<span class=money>£209.00</span>",
            
              compare_price: "<span class=money>£588.00</span>",
              saving_price: "<span class=money>£379</span>",
              saving_html: "save " + "64" + "%",
            
            shoppay_price: "<span class=money>£52.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344275_1000x.webp?v=1739342426"
          });
        
        var options = '';
        
          options += 'Raw Chocolate (Decaf)';
          
            options += ',';
          
        
          options += '2x bags | no accessories';
          
        
        variantInfo.push({
          id: 43654520045751,
          options,
          title: "Raw Chocolate (Decaf) / 2x bags | no accessories",
          price: "<span class=money>£69.00</span>",
          compare_price: "<span class=money>£98.00</span>",
          shoppay_price: "<span class=money>£17.25</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£29.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344275_1000x.webp?v=1739342426",
          selling_plans
        })
      
        
        var selling_plans = [];
        
          
          
          
          selling_plans.push({
            id: 1393393847,
            name: "Every 1 Month",
            per_serving: "(<span class=money>£0.76</span>/serving)",
            subs_saving_price: "<span class=money>£23.00</span>",
            price: "<span class=money>£69.00</span>",
            
              compare_price: "<span class=money>£147.00</span>",
              saving_price: "<span class=money>£78</span>",
              saving_html: "save " + "53" + "%",
            
            shoppay_price: "<span class=money>£17.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344349_1000x.webp?v=1739342433"
          });
        
          
          
          
          selling_plans.push({
            id: 1393426615,
            name: "Every 3 Months",
            per_serving: "(<span class=money>£0.62</span>/serving)",
            subs_saving_price: "<span class=money>£18.77</span>",
            price: "<span class=money>£169.00</span>",
            
              compare_price: "<span class=money>£441.00</span>",
              saving_price: "<span class=money>£272</span>",
              saving_html: "save " + "62" + "%",
            
            shoppay_price: "<span class=money>£42.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344349_1000x.webp?v=1739342433"
          });
        
          
          
          
          selling_plans.push({
            id: 1393459383,
            name: "Every 6 Months",
            per_serving: "(<span class=money>£0.60</span>/serving)",
            subs_saving_price: "<span class=money>£18.27</span>",
            price: "<span class=money>£329.00</span>",
            
              compare_price: "<span class=money>£882.00</span>",
              saving_price: "<span class=money>£553</span>",
              saving_html: "save " + "63" + "%",
            
            shoppay_price: "<span class=money>£82.25</span>",
            image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344349_1000x.webp?v=1739342433"
          });
        
        var options = '';
        
          options += 'Raw Chocolate (Decaf)';
          
            options += ',';
          
        
          options += '3x bags | no accessories';
          
        
        variantInfo.push({
          id: 43654520144055,
          options,
          title: "Raw Chocolate (Decaf) / 3x bags | no accessories",
          price: "<span class=money>£89.00</span>",
          compare_price: "<span class=money>£147.00</span>",
          shoppay_price: "<span class=money>£22.25</span>",
          per_serving: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1012): divided by 0",
          subs_saving_price: "Liquid error (snippets/variants_picker-free-no-accessories-frequency_updated line 1013): divided by 0",
          available: "true" === "true",
          
            saving_price: "<span class=money>£58.00</span>",
          
          image: "//spacegoods.com/cdn/shop/files/rainbow-dust-starter-kit-Spacegoods-87344349_1000x.webp?v=1739342433",
          selling_plans
        })
      
  
      console.log('variantInfo: ', variantInfo);
  
      $('.selector_content .option_selector.s_sub_quan_selector.in_two_options_holder').on("click", function () {
          console.log('option click for flavor/quantity');
          $(this).closest('.subs_quan_selector').find('.s_sub_quan_selector.in_two_options_holder').removeClass('selected');
          $(this).addClass('selected');
  
          const option_id = $(this).attr('option-id');
          const option_value = $(this).attr('option-value');
  
          console.log('option_id: ', option_id);
          console.log('option_value: ', option_value);
  
          selectedVariantOptions[+option_id] = option_value;
  
          console.log('selectedVariantOptions: ', selectedVariantOptions);
  
          const selectedVariant = getSelectedVariant();
          selectedSubscriptionVariantId = selectedVariant.id;
          selectedSellingPlanId = selectedVariant.selling_plans[0].id;
  
          
          console.log('selectedSubscriptionVariantId: ', selectedSubscriptionVariantId);
          console.log('selectedSellingPlanId: ', selectedSellingPlanId);
          
          if (tabState === 'free') {
            freeAccessoriesSelectedVariantOptions = selectedVariantOptions;
            freeAccessoriesSellingPlanId = selectedSellingPlanId;
          } else {
            noAccessoriesSelectedVariantOptions = selectedVariantOptions;
            noAccessoriesSellingPlanId = selectedSellingPlanId;
          }
  
          updateFrequencyDom();
          updatePrice();
          updateATCAttribute();
          update_pdp_slider_img(selectedSubscriptionVariantId);
  
        // $('.s_sub_quan_selector.selected.bag').trigger('click');
      });
  
      const getSelectedVariant = () => {
          console.log(selectedVariantOptions.join(','));
        console.log('VARIANT INFO', selectedVariantOptions);
          return variantInfo.find(variant => variant.options === selectedVariantOptions.join(','));
        
      }
  
      const selectedFrequencyOption = (element) => {
          console.log('frequency option click');
          $(element).parent().find('.s_sub_quan_selector.in_two_options_holder').removeClass('selected');
          $(element).addClass('selected');
  
          selectedSellingPlanId = $(element).data('id');
  
          if (tabState === 'free') {
            freeAccessoriesSellingPlanId = selectedSellingPlanId;
          } else {
            noAccessoriesSellingPlanId = selectedSellingPlanId;
          }
  
          updatePrice();
          updateATCAttribute();
      }
  
      const updateFrequencyDom = () => {
          const selectedVariant = getSelectedVariant();
          let html = '';
  
          console.log('update frequency dom: ', selectedVariant.selling_plans);
  
          selectedVariant.selling_plans.forEach((sellingPlan, index) => {
              html += `
                  <div class="s_sub_quan_selector in_two_options_holder ${index == 0 ? 'selected' : ''}" data-id="${sellingPlan.id}" onclick="selectedFrequencyOption(this)">
                      <div class="s_sub_saving_badge ">save ${sellingPlan.saving_price}</div>
                      <div class="frequency-option-value frequency">
                          <div class="s_quan_txt testing" data-id="${sellingPlan.id}"><span>${sellingPlan.name}</span></div>
                      </div>
                  </div>
              `;
          });
  
          // $('.subs_quan_selector.frequency-option').html(html);
      }
  
      const updatePrice = () => {
  
  
        var selectedVariant = getSelectedVariant();
      
        const selectedSellingPlan = selectedVariant.selling_plans[0];
  
  
        var selectedMode = $('.s_selector.selected').attr('for');
        if (selectedMode == 'free_accessories'){
          $('.pp_tag.acc').show();
        }
        else{
          $('.pp_tag.acc').hide();
        }
     
        
        if (selectedSellingPlan &&
            typeof selectedSellingPlan.subs_saving_price !== 'undefined' &&
            typeof selectedSellingPlan.per_serving !== 'undefined' &&
            typeof selectedSellingPlan.price !== 'undefined' &&
            typeof selectedSellingPlan.compare_price !== 'undefined' &&
            typeof selectedSellingPlan.saving_html !== 'undefined') {
  
  
           console.log('compare price: ', selectedSellingPlan.compare_price);
           console.log('saving_html: ', selectedSellingPlan.saving_html);
  
        
            var selected_Saving_price = selectedSellingPlan.subs_saving_price;
            var selectedPerServing = selectedSellingPlan.per_serving;
            var selectedPrice = selectedSellingPlan.price;
            var selectedComparePrice = selectedSellingPlan.compare_price;
            var selectedSavingHtml = selectedSellingPlan.saving_html;
        
            var perServingBeauty = String(selectedPerServing).replace('(', '').replace('/serving)', '')
            
            $('.s_selector.selected .subs_saving_price').html(selected_Saving_price);
            $('.s_selector.selected .per-serving').html(selectedPerServing);
  
            $('.pp_tag.serving').html('From '+perServingBeauty+' per serving');
        
            $('.main_cta .total_price').html(selectedPrice);
            $('.p_price').html(selectedPrice);
            $('.p_price').append('<span class="comp_price">' + selectedComparePrice + '</span>' + 
                                 '<span class="saving_percent upd"><span><img src="https://cdn.shopify.com/s/files/1/0588/9307/4615/files/Star_497fd68f-88be-4886-9c15-65bb40886971.png?v=1737095746"></span><span>' + (selectedSavingHtml || '') + '</span></span>');
        } else {
            console.error("One or more properties are missing in selectedSellingPlan.");
        
            var selected_Saving_price = selectedSellingPlan.subs_saving_price;
            var selectedPerServing = selectedSellingPlan.per_serving;
            var selectedPrice = selectedSellingPlan.price;
            var selectedComparePrice = selectedSellingPlan.compare_price;
            var selectedSavingHtml = selectedSellingPlan.saving_html;
        
            $('.s_selector.selected .subs_saving_price').html(selected_Saving_price);
            $('.s_selector.selected .per-serving').html(selectedPerServing);
        
            $('.main_cta .total_price').html(selectedPrice);
        
            $('.p_price').html(selectedPrice);
            $('.p_price').append('<span class="comp_price">' + selectedComparePrice + '</span>' + 
              '<span class="saving_percent upd"><span><img src="https://cdn.shopify.com/s/files/1/0588/9307/4615/files/Star_497fd68f-88be-4886-9c15-65bb40886971.png?v=1737095746"></span><span>' + (selectedSavingHtml || '') + '</span></span>');
          
        }
      }
  
      const updateATCAttribute = () => {
         
         $('.main_cta').attr('s_id', selectedSellingPlanId);
          $('.main_cta').attr('v_id', selectedSubscriptionVariantId);
      }
  
      $('.selector_content[from="free_accessories"] .s_sub_quan_selector').not('.in_two_options_holder').click(function () {
          console.log('free accessories selector clicking');
          $('.selector_content[from="free_accessories"] .s_sub_quan_selector').not('.in_two_options_holder').removeClass('selected');
          $(this).addClass('selected');
          
          tabState = 'free';
          selectedVariantOptions = freeAccessoriesSelectedVariantOptions;
          selectedSellingPlanId = freeAccessoriesSellingPlanId;
  
          updateFrequencyDom();
          updatePrice();
          updateATCAttribute();
          update_pdp_slider_img(selectedSubscriptionVariantId);
  
        // $('.s_sub_quan_selector.selected.bag').trigger('click');
      });
  
      $('.selector_content[from="no_accessories"] .s_sub_quan_selector').not('.in_two_options_holder').click(function () {
          console.log('no accessories selector clicking');
        console.log('Here form line 1064');
          $('.selector_content[from="no_accessories"] .s_sub_quan_selector').not('.in_two_options_holder').removeClass('selected');
          $(this).addClass('selected');
  
          tabState = 'no';
          selectedVariantOptions = noAccessoriesSelectedVariantOptions;
          selectedSellingPlanId = noAccessoriesSellingPlanId;
  
          updateFrequencyDom();
          updatePrice();
          updateATCAttribute();
          update_pdp_slider_img(selectedSubscriptionVariantId);
  
        // $('.s_sub_quan_selector.selected.bag').trigger('click');
      });
  
      setTimeout(() => {
          $('.s_selector.selected').trigger('click'); 
      }, 300);

  


      $('.accordion_header').click(function () {
          $('.accordion_header').not(this).removeClass('slided');
          $('.accordion_header').not(this).next().slideUp();
          $(this).toggleClass('slided');
          $(this).next().slideToggle();
      });



$('#product_temp_main .ingre_btn').on('click', function(){
    var selectedMode = $('#product_temp_main .s_selector.selected').attr('for');
    var selected_flavor_option = $('#product_temp_main .selector_content[from="' + selectedMode + '"] .subs_quan_selector.flavour-option .s_sub_quan_selector.selected .s_quan_txt').eq(0).text();
    $(".modal_item").addClass("hide");
    $(`.modal_item[flavor='${selected_flavor_option}']`).removeClass("hide");
    $('#product_temp_main .ingre_modal_overlay').addClass('active');
    $('#product_temp_main .ingre_modal').addClass('active');
    $('#product_temp_main .modal_heading_wrapper').trigger('click');        
    $('body').addClass('overlaid');
});
$('#product_temp_main .ingre_modal .close_btn_wrapper').on('click', function(){
    close_nutrition_popup();
});
function close_nutrition_popup() {
    $('#product_temp_main .ingre_modal_overlay').removeClass('active');
    $('#product_temp_main .ingre_modal').removeClass('active');
    $('body').removeClass('overlaid');
}
$('#product_temp_main .modal_item_heading').on('click', function(){
    var parent_el = $(this).closest('.modal_item');
    $('#product_temp_main .modal_item').not(parent_el).removeClass('active');
    $('#product_temp_main .modal_item').not(parent_el).find('.modal_image').slideUp();
    parent_el.toggleClass('active');
    parent_el.find('.modal_image').slideToggle();
});

setTimeout(function(){
  var selectedId =  $('.main_cta').attr('s_id_old');
  $('.main_cta').attr('s_id', selectedId);
  console.log('PRESETTED ID ========');
},500);


$(document).ready(function(){
    $('.pp_why_use_btn_mn').click(function(evt){
        evt.preventDefault();

        $('html, body').animate({
            scrollTop: $("#product_temp_main").offset().top
        }, 500);
    });
});




Product = new Object();
Product.init = function() {
Product.accordion();
};

Product.calculateDeliveryDate = function(x) {
// Get the current date
var currentDate = new Date();

// Define days and months arrays
var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function addBusinessDays(startDate, numDays) {
    var newDate = new Date(startDate);
    var businessDays = 0;

    while (businessDays < numDays) {
    newDate.setDate(newDate.getDate() + 1);

    // Check if the current day is a business day (Monday to Friday)
    if (newDate.getDay() !== 0 ) {
        businessDays++;
    }
    }

    return newDate;
}

// Calculate the first delivery date (skipping weekends)
var firstDeliveryDate = addBusinessDays(currentDate, x);

// Get day, date, and month for the first delivery date
var firstDayName = days[firstDeliveryDate.getDay()];
var firstDay = firstDeliveryDate.getDate();
var firstMonth = months[firstDeliveryDate.getMonth()];

// Format the first delivery date string
var firstFormattedDate = firstDayName + ', ' + firstDay + ' ' + firstMonth;

// Display the formatted first delivery date
$('.pp_delivery_date').text(firstFormattedDate);


}

var currentUrl = String(window.location.href);
if (currentUrl.indexOf('en-eu') != -1 || currentUrl.indexOf('en-us') != -1){
    Product.calculateDeliveryDate(5 );
}
else{
    Product.calculateDeliveryDate(2 );
}
document.addEventListener("DOMContentLoaded", function () {
  var thumbs_swiper = new Swiper(".thumbs_swiper", {
    spaceBetween: 5,
    slidesPerView: 3,
    initialSlide: 0,
    breakpoints: {
      900: {
        slidesPerView: 7,
        spaceBetween: 4
      },
    },
  });

  var main_swiper = new Swiper(".main_swiper", {
    spaceBetween: 10,
    initialSlide: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumbs_swiper,
    },
    on: {
      init: function () {
        thumbs_swiper.slideTo(0);
      },
    },
  });

  // Make sure both swipers recalculate layout
  main_swiper.update();
  thumbs_swiper.update();
});








function goto_loox_section() {
  $('html, body').animate({
      scrollTop: $(".pdp_loox_section").offset().top - 100
  }, 2000);
}




// Varinat wise free product image shoe script
function showMatchingGroup() {
  var mainCtaButton = document.querySelector('.main_cta');
  if (mainCtaButton) {
      var v_id = mainCtaButton.getAttribute('v_id');
      document.querySelectorAll('.variantidGroup').forEach(function (group) {
          group.style.display = 'none';
      });
      var matchingGroups = document.querySelectorAll('.variantidGroup[data-variant-id="' + v_id + '"]');
      matchingGroups.forEach(function (group) {
          group.style.display = 'flex';
      });
  }
}
showMatchingGroup();
var observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.target.classList.contains('main_cta')) {
          showMatchingGroup();
      }
  });
});
observer.observe(document.body, {
  attributes: true,
  subtree: true,
  attributeFilter: ['v_id']
});
// Varinat wise free product image shoe script End



$(".s_sub_quan_selector, .variant_option_selector.flavour").on("click", function () {
  /* general flavor option checking */
  // console.log("%cflavor option clicking separate to main function", "border-radius: 2px; background-color:blue; color: white; padding: 2px; border-bottom: 1px dashed #81b49c;");
  var active_flavor = $(".flavour-option .s_sub_quan_selector.selected .s_quan_txt").eq(0).text();
  if ($(this).hasClass("variant_option_selector")) {
      active_flavor = $(this).attr('option-value');
  }

  console.log("active_flavor", active_flavor);
  $("[data-flavor]").each(function () {
      var flavor_options = $(this).attr("data-flavor").trim().split(",");
      var flavor_selected = false;
      for (let index = 0; index < flavor_options.length; index++) {
          // console.log("flavor option", flavor_options[index]);
          if ((flavor_options[index]).trim() == active_flavor) {
              flavor_selected = true;
          }
      }
      // console.log("flavor_option", flavor_options, active_flavor); 
      if (flavor_selected == true) {
          $(this).show();
      }
      else {
          $(this).hide();
      }
  });
  /* upsell block update for flavor option */
  setTimeout(() => {
      $(".upsell_holder").show();
      var visible_upsell_box_length = $(".upsell_holder .upsell_box:visible").length;
      if (visible_upsell_box_length == 0) {
          $(".upsell_holder").hide();
      }
  }, 500);
});
$(".s_sub_quan_selector").eq(0).trigger("click");




{/* <script id="looxSchemaJson" type="application/ld+json">
{
  "@context": "http://schema.org",
  "@type": "Product",
  "@id": "https:\/\/spacegoods.com\/products\/rainbow-dust-starter-kit",
  "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.7",
      "reviewCount": "5548"
  },
  "name": "rainbow dust starter kit -"

  ,"review" : [{"@type":"Review","author":{"@type":"Person","name":"Nuno S."},"datePublished":"2025-02-27T22:12:09.673Z","reviewBody":"Best quality ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Michelle J."},"datePublished":"2025-02-27T17:31:07.780Z","reviewBody":"I am totally surprised by how chocolatey this tastes. I am going to continue on this journey and drink Rainbow Dust every day. I would recommend everyone samples this amazing range of products. ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Laura S."},"datePublished":"2025-02-27T16:57:19.609Z","reviewBody":"Love the taste - will definitely be ordering more.","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Marcin B."},"datePublished":"2025-02-27T16:31:08.353Z","reviewBody":"Really good pack! Chocolate flavour is the best in my opinion. It is on the top on my list, just behind is vanilla and cinnamon ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Jasna T."},"datePublished":"2025-02-27T15:31:26.664Z","reviewBody":"I was a bit skeptical at first, and it did take me a couple of days to get used to the fact that you don't get and instant kick, but now I greatly prefer it over coffee. Prep is fast and easy, taste is good, the effects are positive and I sleep great even if I have 2 cups (which was not the case with coffee). I ordered a bundle now.","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Pragati D."},"datePublished":"2025-02-27T15:14:44.747Z","reviewBody":"Finally found a good replacement for my cofee addiction , Genuinely recommended alternate! Love the cinamon flavour, cant wait to try others ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Gwen B."},"datePublished":"2025-02-27T13:03:24.072Z","reviewBody":"I love the chai flavour, great for in the day. The accessories in the pack are great, although I'm not a fan of pink","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Tihomir T."},"datePublished":"2025-02-27T10:40:22.924Z","reviewBody":"Good product, fast and easy communication with the support . ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Rebecca M."},"datePublished":"2025-02-27T07:37:56.921Z","reviewBody":"Love this stuff.  Taste better than coffee ☕️ \nBut better for you. \nI now drink this without milk as it tastes so good  ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Oliver K."},"datePublished":"2025-02-26T17:23:25.358Z","reviewBody":"Pride of place on the shelf! Love the feeling it gives me, it's improved my general mood and focus, I got the coffee flavour which I have black and it starts my day off right! ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Liang Yuan M."},"datePublished":"2025-02-26T17:16:09.276Z","reviewBody":"It is really working I was skeptical , but when I'm studying I can feel myself more focus and less forgetful which is great, tad bit expensive though :( and the delivery outside UK is a bit wanky ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Kassendra R."},"datePublished":"2025-02-26T14:35:48.443Z","reviewBody":"It really keeps me focused and calm","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Salvatore F."},"datePublished":"2025-02-26T14:10:57.451Z","reviewBody":"Super\n","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Corey J."},"datePublished":"2025-02-26T13:14:52.469Z","reviewBody":"I can’t believe how much this really works. I have one every morning and they get me through the whole day, no crash!\n\nDefinitely would recommend","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Mrs A."},"datePublished":"2025-02-25T23:03:49.810Z","reviewBody":"Absolutely love rainbow dust! The energy I've had for the last month and half since using it is unreal! ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Sarika J."},"datePublished":"2025-02-25T21:09:40.056Z","reviewBody":"So this is great it’s definitely helped me detox from the caffeine crave in the morning - the need to have a coffee before I leave the house - now I can do the school run, come back make a cup of rainbow dust and start my day. \nFeels good, no mid day or post lunch low… it’s been about 2/3 weeks so let’s see….  ","reviewRating":{"@type":"Rating","ratingValue":4}},{"@type":"Review","author":{"@type":"Person","name":"Karen P."},"datePublished":"2025-02-25T20:54:45.394Z","reviewBody":"I notice my energy levels is much better in the mornings. I take this instead of my daily coffees and I feel much healthier. ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Julie P."},"datePublished":"2025-02-25T20:54:10.250Z","reviewBody":"Lovely delicious drink","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Nicola D."},"datePublished":"2025-02-25T20:43:04.882Z","reviewBody":"Fab tasting product Shame it's so expensive ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Emma L."},"datePublished":"2025-02-25T19:58:21.930Z","reviewBody":"I've enjoyed adding the spacedust to my morning shake, it is tasty and keeps me pepped up without the caffeine highs and lows all morning.","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Livia P."},"datePublished":"2025-02-25T18:24:59.165Z","reviewBody":"The taste is good, got coffee, tastes more like instant coffee to be honest. Also I was surprised that it does contain so much caffeine in a portion, so beware that if you are actually trying to avoid caffeine ","reviewRating":{"@type":"Rating","ratingValue":4}},{"@type":"Review","author":{"@type":"Person","name":"Alissa K."},"datePublished":"2025-02-25T12:58:18.891Z","reviewBody":"Happy with it","reviewRating":{"@type":"Rating","ratingValue":4}},{"@type":"Review","author":{"@type":"Person","name":"Greg D."},"datePublished":"2025-02-25T09:03:53.330Z","reviewBody":"I love the product. I feel i'm definitely more focused and have better energy levels. But Ive been having the craziest lucid dreams since i started taking it. I reduced my daily intake of by half a measure and it definitely has helped with the nocturnal neural ramblings :)","reviewRating":{"@type":"Rating","ratingValue":4}},{"@type":"Review","author":{"@type":"Person","name":"Sonia G."},"datePublished":"2025-02-24T22:53:13.181Z","reviewBody":"It's brilliant,! I've been taking it every morning as a coffee substitute and it's made such a difference on my day!! Just ordered another bag plus the Astro dust .","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Izabele P."},"datePublished":"2025-02-24T20:19:49.698Z","reviewBody":"So far so good ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Andrew D."},"datePublished":"2025-02-24T14:11:58.322Z","reviewBody":"Does the job but I didn’t realise it had actual coffee in it is there an alternative without? ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Sarah S."},"datePublished":"2025-02-24T09:04:21.939Z","reviewBody":"It's been wonderful to start the day with space dust....I have mine with frothy oat milk...feels perfect me time and sets me up for the day","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Emma N."},"datePublished":"2025-02-24T08:48:09.957Z","reviewBody":"Felt more focus and drive ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Barry J."},"datePublished":"2025-02-23T23:24:22.028Z","reviewBody":"I no longer drink coffee. or caffienated energy drinks. This is huge.\nThe resulting drink that I make from the powder tastes good, I drink it twice a day.  \nI hope it can find space on the high street shelves.","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Robin B."},"datePublished":"2025-02-23T19:14:10.242Z","reviewBody":"Came very quickly second time around and I am enjoying product. So far so good.\nThank you.","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Kieron F."},"datePublished":"2025-02-23T18:16:33.605Z","reviewBody":"Definitely feel more alert and switched on throughout the day. Coffee flavour tastes great. ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Kenneth D."},"datePublished":"2025-02-23T12:59:36.362Z","reviewBody":"Only starting so not much to say except the customer services was great and the free extras also very useful.","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"W M."},"datePublished":"2025-02-23T12:47:02.978Z","reviewBody":"Rainbow Dust works for me!\nI've been drinking Rainbow Dust for a while now, and I've definitely noticed a positive difference. I used to get energy crashes in the afternoons, even after a regular coffee. Since switching to Rainbow Dust in the afternoons, I get a noticeable and quick energy boost. This has allowed me to cut back to just one cup of regular coffee in the morning which I love.\nGreat job, Spacegoods!","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Phillip L."},"datePublished":"2025-02-23T10:10:58.635Z","reviewBody":"After introducing space goods to my morning routine a over a month ago I can say my brain fog is starting to clear and my days are a lot more productive. It probably won't work for everyone but it's definitely worth giving it a try and see if it works for you the price is a little edgy but is well worth the money and comes beautifully packaged. \n10/10 ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Lucie K."},"datePublished":"2025-02-23T08:57:48.578Z","reviewBody":"Great service, taste is amazing . Best I have tried . \nToo early to tell about the benefits ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Victoria B."},"datePublished":"2025-02-22T23:29:14.120Z","reviewBody":"Leaves me feeling calmer","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Helen J."},"datePublished":"2025-02-22T21:59:08.000Z","reviewBody":"Just love this flavour","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Helen J."},"datePublished":"2025-02-22T21:58:48.000Z","reviewBody":"Coffee flavour is ok too , easy to make n can drink it hot or hold","reviewRating":{"@type":"Rating","ratingValue":4}},{"@type":"Review","author":{"@type":"Person","name":"Isabel N."},"datePublished":"2025-02-22T15:49:59.924Z","reviewBody":"Very good taste! I drink it every morning with whey protein.","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"William D."},"datePublished":"2025-02-22T14:07:16.947Z","reviewBody":"Great product ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Amanda S."},"datePublished":"2025-02-22T09:36:06.007Z","reviewBody":"Love this one taste is fabulous. Its easy to mix and taste great too.","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Eurika R."},"datePublished":"2025-02-22T08:03:35.935Z","reviewBody":"We love it first cup every morning. FABULOUS!!!!! ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Laura B."},"datePublished":"2025-02-21T22:03:22.405Z","reviewBody":"Great product, quick fast service and excellent bargain with the starter pack, I’m hooked! No coffee crash but same routine as my usual mornings and energy ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Jade F."},"datePublished":"2025-02-21T21:16:30.294Z","reviewBody":"Amazing experience with this kit and I am on subscription for both space and Astro dust. ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Darren P."},"datePublished":"2025-02-21T20:54:05.448Z","reviewBody":"Taste good and works a treat. Focus focus focus!!","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Jodie G."},"datePublished":"2025-02-21T20:10:09.505Z","reviewBody":"I find this a nice change up from the chocolate. I felt an effect from the first cup full  I have fibromyalgia and the increased energy levels I have since starting 1 cup a day has definitely helped me push through even tho my pain levels are extremely high ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Charmaime M."},"datePublished":"2025-02-21T17:41:24.500Z","reviewBody":"Love the product, really feeling the difference in my mood and energy.","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Alex F."},"datePublished":"2025-02-21T15:07:52.768Z","reviewBody":"I've noticed a big improvement in focus and more energy in the afternoons ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Andreea T."},"datePublished":"2025-02-21T08:39:24.159Z","reviewBody":"great","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Mandy G."},"datePublished":"2025-02-20T23:35:13.484Z","reviewBody":"It’s great , once I’d figure my best way to drink I have it every morning. I may need some more soon.","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Zurainee T."},"datePublished":"2025-02-20T21:35:57.902Z","reviewBody":"Amazing taste to keep me going all day. ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Andrea C."},"datePublished":"2025-02-20T19:50:45.024Z","reviewBody":"The first bag really made the difference. I felt more focus but now I want to try the version without caffeine because it is easy to work on caffeine, i need something different to actually understand if it works ","reviewRating":{"@type":"Rating","ratingValue":4}},{"@type":"Review","author":{"@type":"Person","name":"Carina O."},"datePublished":"2025-02-20T18:38:06.673Z","reviewBody":"I love this stuff!!","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Gerry P."},"datePublished":"2025-02-20T17:54:12.647Z","reviewBody":"Started it last week, dropped out coffee completely and feel sharper mentally and physically. Looking forward to trying the evening samples.","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Valeria L."},"datePublished":"2025-02-20T17:54:04.151Z","reviewBody":"I feel really good when i drink the spacegood mushroom coffee. I've tried another kind in a cafe and had the same effect. I feel a boost in my mood and energy, the day goes by and yiu feel so much better than on coffee. It works great and I don't mind the taste, (it actually reminds me more of chicory root than mushrooms); i serve it with coconut milk. ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Martel M."},"datePublished":"2025-02-20T17:10:28.298Z","reviewBody":"Good quality accessories to accompany the rainbow dust! Definitely helped me focus more!","reviewRating":{"@type":"Rating","ratingValue":4}},{"@type":"Review","author":{"@type":"Person","name":"Inge B."},"datePublished":"2025-02-20T12:45:45.288Z","reviewBody":"Best part of my day is my new morning routine with my spacey awesome beverage and the starter kit is such a perfect gift to myself and the experience of making and enjoying it. Thank you.","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Karen O."},"datePublished":"2025-02-20T01:29:19.033Z","reviewBody":"I have the chocolate flavour. This is a good hot chocolate as well as having the mushroom benefits. I suffer from chronic fatigue syndrome/ME, but I think the mushrooms only make a mild difference to me. Also, I do not want to have the pressure of a subscription, and I think that the product is rather expensive, but is of good quality. Much better than the cheaper ones I have tried.","reviewRating":{"@type":"Rating","ratingValue":4}},{"@type":"Review","author":{"@type":"Person","name":"Emma D."},"datePublished":"2025-02-19T21:02:05.835Z","reviewBody":"Love this product! I feel more energised throughout the day and it tastes really nice. I’m a big fan of the ingredients, tastes like a hot chocolate! ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Amy G."},"datePublished":"2025-02-19T14:44:02.078Z","reviewBody":"I really like the refreshing taste of space goods! It makes a great alternative to my coffee, with a similar feel and a warming feeling. I can’t wait to try the chocolate flavour!","reviewRating":{"@type":"Rating","ratingValue":4}},{"@type":"Review","author":{"@type":"Person","name":"Vanora M."},"datePublished":"2025-02-19T13:53:28.593Z","reviewBody":"Felt more alert straight away on day 1 & found it a real help for menopausal brain fog. Plus the taste is lovely and I’m not a coffee drinker but this one I like ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Daniel M."},"datePublished":"2025-02-19T13:41:56.565Z","reviewBody":"Really love Spacegoods. I suffered from Heartburn for YEARS since I was about 14. Realising I drink alot of coffee I bought a bundle which came with 2 cups, tin and frother. Great value but I lost a cup when travelling fuming. But no joke drinking spacegood hugely decreased my heartburn 10 fold and the taste is pleasant but I do have 2 sugars with it!  ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Sara C."},"datePublished":"2025-02-19T08:32:38.299Z","reviewBody":"For those who don’t want anything sweet, try raw cacao—it’s amazing! To balance it, you can add some almond milk foam, and it becomes the perfect drink for cold mornings.","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Lucy M."},"datePublished":"2025-02-18T22:03:53.662Z","reviewBody":"This is now my morning routine! Love!! ❤️ ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Aoife M."},"datePublished":"2025-02-18T21:53:10.804Z","reviewBody":"","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Rachael T."},"datePublished":"2025-02-18T18:18:30.000Z","reviewBody":"Great price for the bundle and the rainbow dust helps with what it says and tastes really nice","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Neville C."},"datePublished":"2025-02-18T14:38:15.692Z","reviewBody":"Taste amazing, makes me feel amazing, no crash or jitters. Amazing product, I am very Happy with it. Well done spacegoods!","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Christina C."},"datePublished":"2025-02-18T12:55:33.920Z","reviewBody":"I have ADHD and experience fatigue and lack of focus every day. This helps me so much, I was skeptical of course but wow. Will be ordering again!","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Bea M."},"datePublished":"2025-02-18T12:37:58.809Z","reviewBody":"Fantástico sabor y una sensación de mayor ligereza y energía. Sienta muy bien al estómago. Repito compra seguro. ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Karen W."},"datePublished":"2025-02-17T21:18:28.374Z","reviewBody":"Does seem to work for me actually takes my aches n pains away as well as making me feel calm.   I did make a mistake when ordering as I thought I had ordered chocolate but I ordered coffee.   Wasn’t bad but had a bitter aftertaste now changed to chocolate ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Anda S."},"datePublished":"2025-02-17T18:07:45.595Z","reviewBody":"Taste is delicious and it keeps me going and focused through the day. The Package needs a little more in it as I'm almost out already!","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Leon H."},"datePublished":"2025-02-17T17:47:39.829Z","reviewBody":"Amazing product delicious but more to the point does exactly what hat it says on the bag longer focus no crash just a brilliant product !","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Robert O."},"datePublished":"2025-02-17T16:28:39.257Z","reviewBody":"Super bought 3 more bags\n","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Kloe R."},"datePublished":"2025-02-16T21:10:13.616Z","reviewBody":"Absolutely loving this I don’t like eating mushrooms because of their texture but this is tasty in strawberry & I’ve had 3-4 weeks where I’m more focused on my work goals ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Paul C."},"datePublished":"2025-02-16T19:55:57.873Z","reviewBody":"Great","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Priya P."},"datePublished":"2025-02-16T19:47:01.646Z","reviewBody":"Really helped me to concentrate & noticeably reduced brain fog! ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Graham R."},"datePublished":"2025-02-16T16:19:34.963Z","reviewBody":"I'm enjoying the beginning of this journey ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Sam G."},"datePublished":"2025-02-16T16:13:06.712Z","reviewBody":"It’s so yummy  ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Cherelle P."},"datePublished":"2025-02-16T16:06:44.396Z","reviewBody":"This really works!! The starter kit is very cute and is an overall pleasant experience when preparing my drink. Ive experienced less brain fog and better decision making through using this product. Funghi is the best!  Thank you spacegoods for a delicious healthy alternative to stuff like tea/ coffee. I chose the vanilla/ cinnamon flavour which is kind of like chai latte which is perfect. Would recommend to everyone and anyone. ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Sheila H."},"datePublished":"2025-02-16T14:40:06.957Z","reviewBody":"Great start to the day!!","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Jonathan M."},"datePublished":"2025-02-16T13:54:49.605Z","reviewBody":"Great tasting product .. almost tastes like coffee however without the drawbacks. Definitely feel the difference after drinking it ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Adam L."},"datePublished":"2025-02-16T11:17:15.024Z","reviewBody":"Great taste, great product","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Mari-vic G."},"datePublished":"2025-02-15T17:22:12.144Z","reviewBody":"Uplifting and energising. I really look forward to my treat. I use oat milk which I heat up then a little water. It’s a Rainbow Dust latte in my Rainbow mug. Just magick! Thankyou. ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Pomo M."},"datePublished":"2025-02-15T16:55:46.886Z","reviewBody":"Feeling great. Positive and active!","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Kumayl F."},"datePublished":"2025-02-15T16:30:03.525Z","reviewBody":"The items were delivered with care and very quickly, and am happy with the coffee","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"James S."},"datePublished":"2025-02-15T16:28:02.802Z","reviewBody":"I'm not going to lie, I didn't like this at first. But that's my fault, I was putting too much in my cup. I put it away and cancelled my subscription. A few days later I tried it again after seeing another ad on social media and reading you can add milk etc in with it. \n\nIt's been 20+ days since I last had a \"real\" cup of coffee. This stuff has taken over my life, the difference that this makes could be described as magic. My mind feels clear, it makes my work much easier to tackle.\n\nSafe to say my subscription is back up & running ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Simonne B."},"datePublished":"2025-02-15T15:34:57.497Z","reviewBody":".","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Anne-marie C."},"datePublished":"2025-02-15T13:35:31.479Z","reviewBody":"Loved the product but was disappointed I didn’t get the storage canister and mug in the bright pink ","reviewRating":{"@type":"Rating","ratingValue":4}},{"@type":"Review","author":{"@type":"Person","name":"Kerstin O."},"datePublished":"2025-02-14T16:11:10.982Z","reviewBody":"Tasty start in the day and already feeling improvement after 10 days.","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Rezel J."},"datePublished":"2025-02-14T12:29:50.686Z","reviewBody":"Since I have started using it I get through the day better and it has improved my mood.","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Rui M."},"datePublished":"2025-02-14T09:10:04.136Z","reviewBody":"Awesome","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Siobhan N."},"datePublished":"2025-02-14T07:39:07.000Z","reviewBody":"Great product","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Nicola T."},"datePublished":"2025-02-13T18:35:13.698Z","reviewBody":"I love the vanilla-cinnamon flavour with hot water, I'm not keen on the chocolate flavour but that's just my preference. \nYou get exactly what it says with the starter pack, the coffee isn't the cheapest but it's lovely and I did buy more. ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Sandra M."},"datePublished":"2025-02-13T15:09:35.558Z","reviewBody":"It tastes great and definitely helps me focus on tasks! ","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Jesus P."},"datePublished":"2025-02-13T14:47:04.273Z","reviewBody":"Me ha gustado mucho, muy atentos con el envio y de gran calidad. Siento una energia mejor que el café. Repetiría","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Mike H."},"datePublished":"2025-02-12T23:01:19.573Z","reviewBody":"Can’t go a day without it now. I am more productive and focused. I am more calm and achieve more.","reviewRating":{"@type":"Rating","ratingValue":4}},{"@type":"Review","author":{"@type":"Person","name":"Darina G."},"datePublished":"2025-02-12T19:22:17.820Z","reviewBody":"Excellent!","reviewRating":{"@type":"Rating","ratingValue":5}},{"@type":"Review","author":{"@type":"Person","name":"Timmy O."},"datePublished":"2025-02-12T14:50:34.860Z","reviewBody":"Well Worth the money ","reviewRating":{"@type":"Rating","ratingValue":5}}]

}
</script> */}


// main product js end here 



